var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUtrechtProvincieLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "267px",
    height: "33px",
    viewBox: "0 0 267 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Main-/-Footer-/-Footer---Desktop-(with-Social-Icons)",
    transform: "translate(-1075.000000, -355.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Footer",
    transform: "translate(-1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-32",
    transform: "translate(0.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23",
    transform: "translate(0.000000, 253.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Header-/-Desktop-home",
    transform: "translate(1076.000000, 22.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#000000",
    points: "4.22265264 15.4746166 4.72169793 15.4784714 4.72169793 17.9339594 5.21944022 17.9339594 5.21944022 18.4299397 2.72681979 18.4299397 2.72681979 17.9339594 4.22004666 17.9378142 4.22265264 16.9497083 3.22456208 16.9497083 3.22456208 16.4588677 4.22265264 16.4588677"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "#000000",
    points: "19.1981807 13.0141174 19.6972259 13.0141174 19.6972259 12.520707 19.1981807 12.520707"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#000000",
    points: "18.7004384 13.506243 19.1994837 13.506243 19.1994837 13.0141174 18.7004384 13.0141174"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#000000",
    points: "14.7054701 32.2082983 18.6991354 32.2082983 18.6991354 31.7161728 14.7054701 31.7161728"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#000000",
    points: "19.1994837 18.4313531 19.6985289 18.4313531 19.6985289 17.9353728 19.1994837 17.9353728"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#000000",
    points: "19.1994837 19.4091796 19.6985289 19.4091796 19.6985289 18.917054 19.1994837 18.917054"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    fill: "#000000",
    points: "28.1836017 32.2082983 28.682647 32.2082983 28.682647 31.7161728 28.1836017 31.7161728"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    fill: "#000000",
    points: "20.1962712 29.7489556 20.6953165 29.7489556 20.6953165 29.2555451 20.1962712 29.2555451"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    fill: "#000000",
    points: "19.6985289 29.258115 20.1975742 29.258115 20.1975742 28.272579 19.6985289 28.272579"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    fill: "#000000",
    points: "26.1861176 22.859198 26.6877689 22.859198 26.6877689 22.3670725 26.1861176 22.3670725"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-11",
    fill: "#000000",
    points: "19.1981807 28.272579 19.6972259 28.272579 19.6972259 27.7804534 19.1981807 27.7804534"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-12",
    fill: "#000000",
    points: "20.6953165 30.2410811 21.6947101 30.2410811 21.6947101 29.7489556 20.6953165 29.7489556"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-13",
    fill: "#000000",
    points: "27.1842082 31.2253322 27.6858594 31.2253322 27.6858594 30.7332066 27.1842082 30.7332066"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-14",
    fill: "#000000",
    points: "27.6858594 31.7161728 28.1849047 31.7161728 28.1849047 31.2240473 27.6858594 31.2240473"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-15",
    fill: "#000000",
    points: "23.6908912 3.16646695 24.1899365 3.16646695 24.1899365 2.67562634 23.6908912 2.67562634"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-16",
    fill: "#000000",
    points: "21.6947101 9.07839803 22.1937553 9.07839803 22.1937553 8.58241772 21.6947101 8.58241772"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-17",
    fill: "#000000",
    points: "22.6941036 5.13882388 23.1931489 5.13882388 23.1931489 4.64412849 22.6941036 4.64412849"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-18",
    fill: "#000000",
    points: "21.1930588 8.58241772 21.6934071 8.58241772 21.6934071 8.09029218 21.1930588 8.09029218"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-19",
    fill: "#000000",
    points: "24.6889817 2.18607065 25.18933 2.18607065 25.18933 1.69394511 24.6889817 1.69394511"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-20",
    fill: "#000000",
    points: "22.6941036 2.18607065 23.1931489 2.18607065 23.1931489 1.69394511 22.6941036 1.69394511"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-21",
    fill: "#000000",
    points: "37.668068 13.506243 38.1697193 13.506243 38.1697193 13.0141174 37.668068 13.0141174"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-22",
    fill: "#000000",
    points: "37.1690228 13.9957986 37.668068 13.9957986 37.668068 13.5036731 37.1690228 13.5036731"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-23",
    fill: "#000000",
    points: "37.668068 19.9051599 38.1671133 19.9051599 38.1671133 19.4117494 37.668068 19.4117494"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-24",
    fill: "#000000",
    points: "37.1690228 18.4313531 37.668068 18.4313531 37.668068 17.9353728 37.1690228 17.9353728"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-25",
    fill: "#000000",
    points: "37.1690228 19.4091796 37.668068 19.4091796 37.668068 18.917054 37.1690228 18.917054"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-26",
    fill: "#000000",
    points: "28.1822987 32.2082983 28.68395 32.2082983 28.68395 31.7161728 28.1822987 31.7161728"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-27",
    fill: "#000000",
    points: "36.1696292 29.7489556 36.6686745 29.7489556 36.6686745 29.2555451 36.1696292 29.2555451"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-28",
    fill: "#000000",
    points: "36.6686745 29.258115 37.1677198 29.258115 37.1677198 28.272579 36.6686745 28.272579"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-29",
    fill: "#000000",
    points: "36.6686745 29.258115 37.1677198 29.258115 37.1677198 28.272579 36.6686745 28.272579"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-30",
    fill: "#000000",
    points: "37.1690228 28.272579 37.668068 28.272579 37.668068 27.7804534 37.1690228 27.7804534"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-31",
    fill: "#000000",
    points: "35.1715386 30.2410811 36.1696292 30.2410811 36.1696292 29.7489556 35.1715386 29.7489556"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-32",
    fill: "#000000",
    points: "29.1842983 31.2253322 29.6833435 31.2253322 29.6833435 30.7332066 29.1842983 30.7332066"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-33",
    fill: "#000000",
    points: "28.681344 31.7161728 29.1829953 31.7161728 29.1829953 31.2240473 28.681344 31.2240473"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-34",
    fill: "#000000",
    points: "32.1785699 9.07839803 33.6770088 9.07839803 33.6770088 8.58241772 32.1785699 8.58241772"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-35",
    fill: "#000000",
    points: "32.6789182 3.16646695 33.1779635 3.16646695 33.1779635 2.67562634 32.6789182 2.67562634"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-36",
    fill: "#000000",
    points: "34.6737963 9.07839803 35.1728416 9.07839803 35.1728416 8.58241772 34.6737963 8.58241772"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-37",
    fill: "#000000",
    points: "33.6744028 5.13882388 34.1734481 5.13882388 34.1734481 4.64412849 33.6744028 4.64412849"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-38",
    fill: "#000000",
    points: "35.1715386 8.58241772 35.6705839 8.58241772 35.6705839 8.09029218 35.1715386 8.09029218"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-39",
    fill: "#000000",
    points: "31.6769187 2.18607065 32.177267 2.18607065 32.177267 1.69394511 31.6769187 1.69394511"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-40",
    fill: "#000000",
    points: "33.6744028 2.18607065 34.1734481 2.18607065 34.1734481 1.69394511 33.6744028 1.69394511"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-41",
    fill: "#000000",
    points: "37.668068 18.9221937 38.1697193 18.9221937 38.1697193 13.9983685 37.668068 13.9983685"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-42",
    fill: "#000000",
    points: "19.1981807 20.3972854 25.6896783 20.3972854 25.6896783 19.9051599 19.1981807 19.9051599"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-43",
    fill: "#000000",
    points: "28.1822987 31.2253322 28.681344 31.2253322 28.681344 23.3474688 28.1822987 23.3474688"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-44",
    fill: "#000000",
    points: "26.1861176 18.4313531 26.6877689 18.4313531 26.6877689 17.9353728 26.1861176 17.9353728"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-45",
    fill: "#000000",
    points: "26.6877689 18.9221937 27.1868141 18.9221937 27.1868141 18.4313531 26.6877689 18.4313531"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-46",
    fill: "#000000",
    points: "27.1842082 19.4091796 27.6858594 19.4091796 27.6858594 18.917054 27.1842082 18.917054"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-47",
    fill: "#000000",
    points: "27.6858594 19.9051599 28.1849047 19.9051599 28.1849047 19.4117494 27.6858594 19.4117494"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-48",
    fill: "#000000",
    points: "28.1836017 20.3972854 28.682647 20.3972854 28.682647 19.9051599 28.1836017 19.9051599"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-49",
    fill: "#000000",
    points: "29.1842983 21.3815365 29.6833435 21.3815365 29.6833435 20.889411 29.1842983 20.889411"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-50",
    fill: "#000000",
    points: "28.68395 20.888126 29.1829953 20.888126 29.1829953 20.3972854 28.68395 20.3972854"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-51",
    fill: "#000000",
    points: "29.6820405 21.8723771 30.1823888 21.8723771 30.1823888 21.3802516 29.6820405 21.3802516"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-52",
    fill: "#000000",
    points: "31.1778734 20.3972854 37.669371 20.3972854 37.669371 19.9051599 31.1778734 19.9051599"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-53",
    fill: "#000000",
    points: "24.6889817 8.58241772 32.177267 8.58241772 32.177267 8.09029218 24.6889817 8.09029218"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-54",
    fill: "#000000",
    points: "27.1868141 7.10604111 29.6807376 7.10604111 29.6807376 6.61391557 27.1868141 6.61391557"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-55",
    fill: "#000000",
    points: "31.6769187 6.12307495 35.6731899 6.12307495 35.6731899 5.63094942 31.6769187 5.63094942"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-56",
    fill: "#000000",
    points: "34.1747511 5.62966449 36.6686745 5.62966449 36.6686745 5.13753895 34.1747511 5.13753895"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-57",
    fill: "#000000",
    points: "21.1930588 6.12307495 25.186724 6.12307495 25.186724 5.63094942 21.1930588 5.63094942"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-58",
    fill: "#000000",
    points: "20.2001802 5.62966449 22.6980126 5.62966449 22.6980126 5.13753895 20.2001802 5.13753895"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-59",
    fill: "#000000",
    points: "23.1905429 9.07839803 24.6876788 9.07839803 24.6876788 8.58241772 23.1905429 8.58241772"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-60",
    fill: "#000000",
    points: "23.6924548 6.61378708 24.1915001 6.61378708 24.1915001 7.10591262 25.1882876 7.10591262 25.1882876 7.59932308 24.1915001 7.59932308 24.1915001 8.09016369 23.6924548 8.09016369 23.6924548 7.59932308 23.1934095 7.59932308 23.1934095 7.10591262 23.6924548 7.10591262"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-61",
    fill: "#000000",
    points: "26.1861176 4.15842757 26.6903748 4.15842757 26.6903748 2.18478572 26.1861176 2.18478572"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-62",
    fill: "#000000",
    points: "27.6897684 1.20053465 29.1777833 1.20053465 29.1777833 0.708409108 27.6897684 0.708409108"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-63",
    fill: "#000000",
    points: "28.1849047 2.18555668 28.681344 2.18555668 28.681344 2.67639729 29.1829953 2.67639729 29.1829953 3.16723791 28.681344 3.16723791 28.681344 3.65936345 28.1849047 3.65936345 28.1849047 3.16723791 27.6858594 3.16723791 27.6858594 2.67639729 28.1849047 2.67639729"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-64",
    fill: "#000000",
    points: "37.1690228 13.0141174 37.668068 13.0141174 37.668068 12.520707 37.1690228 12.520707"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-65",
    fill: "#000000",
    points: "36.1696292 13.9957986 36.6686745 13.9957986 36.6686745 13.5036731 36.1696292 13.5036731"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-66",
    fill: "#000000",
    points: "35.6705839 13.506243 36.1696292 13.506243 36.1696292 13.0141174 35.6705839 13.0141174"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-67",
    fill: "#000000",
    points: "35.6705839 15.9668706 36.1696292 15.9668706 36.1696292 15.4747451 35.6705839 15.4747451"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-68",
    fill: "#000000",
    points: "36.1696292 15.477315 36.6686745 15.477315 36.6686745 14.9839045 36.1696292 14.9839045"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-69",
    fill: "#000000",
    points: "33.6744028 18.4313531 34.1734481 18.4313531 34.1734481 17.9353728 33.6744028 17.9353728"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-70",
    fill: "#000000",
    points: "31.1778734 18.918339 32.6776152 18.918339 32.6776152 18.4287833 31.1778734 18.4287833"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-71",
    fill: "#000000",
    points: "32.6789182 18.4313531 33.1779635 18.4313531 33.1779635 17.4445322 32.6789182 17.4445322"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-72",
    fill: "#000000",
    points: "33.1779635 18.918339 35.6744929 18.918339 35.6744929 18.4287833 33.1779635 18.4287833"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-73",
    fill: "#000000",
    points: "35.6744929 18.4262134 36.1709322 18.4262134 36.1709322 16.9498368 35.6744929 16.9498368"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-74",
    fill: "#000000",
    points: "33.6744028 16.9498368 34.1734481 16.9498368 34.1734481 16.4577113 33.6744028 16.4577113"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-75",
    fill: "#000000",
    points: "33.1779635 17.4445322 33.6770088 17.4445322 33.6770088 16.9498368 33.1779635 16.9498368"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-76",
    fill: "#000000",
    points: "34.1747511 17.4445322 34.6737963 17.4445322 34.6737963 16.9498368 34.1747511 16.9498368"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-77",
    fill: "#000000",
    points: "34.6737963 18.4313531 35.1728416 18.4313531 35.1728416 17.4445322 34.6737963 17.4445322"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-78",
    fill: "#000000",
    points: "35.1715386 16.9498368 35.6731899 16.9498368 35.6731899 15.4747451 35.1715386 15.4747451"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-79",
    fill: "#000000",
    points: "34.1734481 16.4577113 34.6737963 16.4577113 34.6737963 15.4747451 34.1734481 15.4747451"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-80",
    fill: "#000000",
    points: "33.1779635 15.9668706 33.6770088 15.9668706 33.6770088 15.4747451 33.1779635 15.4747451"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-81",
    fill: "#000000",
    points: "34.6737963 15.4747451 35.1728416 15.4747451 35.1728416 13.0154023 34.6737963 13.0154023"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-82",
    fill: "#000000",
    points: "33.6770088 15.4747451 34.1747511 15.4747451 34.1747511 14.490494 33.6770088 14.490494"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-83",
    fill: "#000000",
    points: "32.1785699 14.491779 33.6770088 14.491779 33.6770088 13.9983685 32.1785699 13.9983685"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-84",
    fill: "#000000",
    points: "31.1778734 13.9957986 31.6769187 13.9957986 31.6769187 12.520707 31.1778734 12.520707"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-85",
    fill: "#000000",
    points: "31.6769187 13.506243 33.1766605 13.506243 33.1766605 13.0141174 31.6769187 13.0141174"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-86",
    fill: "#000000",
    points: "32.1785699 12.0285814 32.6776152 12.0285814 32.6776152 11.5364559 32.1785699 11.5364559"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-87",
    fill: "#000000",
    points: "33.6770088 12.0285814 34.1747511 12.0285814 34.1747511 11.5364559 33.6770088 11.5364559"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-88",
    fill: "#000000",
    points: "33.1779635 11.5364559 33.6770088 11.5364559 33.6770088 11.0443303 33.1779635 11.0443303"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-89",
    fill: "#000000",
    points: "34.1747511 11.5364559 34.6737963 11.5364559 34.6737963 11.0443303 34.1747511 11.0443303"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-90",
    fill: "#000000",
    points: "33.6770088 11.0456153 35.1728416 11.0456153 35.1728416 10.5534897 33.6770088 10.5534897"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-91",
    fill: "#000000",
    points: "35.1715386 13.0141174 35.6731899 13.0141174 35.6731899 11.0417605 35.1715386 11.0417605"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-92",
    fill: "#000000",
    points: "35.6744929 14.9839045 36.1709322 14.9839045 36.1709322 13.9945137 35.6744929 13.9945137"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-93",
    fill: "#000000",
    points: "32.1785699 16.4577113 33.1779635 16.4577113 33.1779635 15.9655857 32.1785699 15.9655857"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-94",
    fill: "#000000",
    points: "31.6769187 18.4313531 32.177267 18.4313531 32.177267 16.4589962 31.6769187 16.4589962"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-95",
    fill: "#000000",
    points: "36.1696292 13.0141174 36.6686745 13.0141174 36.6686745 11.0430454 36.1696292 11.0430454"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-96",
    fill: "#000000",
    points: "26.6877689 24.3330048 27.1868141 24.3330048 27.1868141 23.8421642 26.6877689 23.8421642"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-97",
    fill: "#000000",
    points: "26.1861176 23.844734 26.6877689 23.844734 26.6877689 23.3526085 26.1861176 23.3526085"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-98",
    fill: "#000000",
    points: "26.6877689 25.8093814 27.1868141 25.8093814 27.1868141 25.3185408 26.6877689 25.3185408"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-99",
    fill: "#000000",
    points: "24.1912395 28.7659894 24.6902847 28.7659894 24.6902847 28.2738639 24.1912395 28.2738639"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-100",
    fill: "#000000",
    points: "23.1905429 28.7659894 23.6908912 28.7659894 23.6908912 27.7778836 23.1905429 27.7778836"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-101",
    fill: "#000000",
    points: "23.6908912 29.2555451 26.1848146 29.2555451 26.1848146 28.7659894 23.6908912 28.7659894"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-102",
    fill: "#000000",
    points: "26.1861176 28.7659894 26.6877689 28.7659894 26.6877689 27.287043 26.1861176 27.287043"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-103",
    fill: "#000000",
    points: "24.1912395 27.287043 24.6902847 27.287043 24.6902847 26.7949174 24.1912395 26.7949174"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-104",
    fill: "#000000",
    points: "23.6908912 27.7804534 24.1899365 27.7804534 24.1899365 27.2883279 23.6908912 27.2883279"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-105",
    fill: "#000000",
    points: "24.6889817 27.7804534 25.188027 27.7804534 25.188027 27.2883279 24.6889817 27.2883279"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-106",
    fill: "#000000",
    points: "25.188027 28.7659894 25.6870723 28.7659894 25.6870723 27.7778836 25.188027 27.7778836"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-107",
    fill: "#000000",
    points: "24.6876788 26.7949174 25.186724 26.7949174 25.186724 25.8093814 24.6876788 25.8093814"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-108",
    fill: "#000000",
    points: "23.6908912 26.3066466 24.1899365 26.3066466 24.1899365 25.8119513 23.6908912 25.8119513"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-109",
    fill: "#000000",
    points: "25.188027 25.8093814 25.6870723 25.8093814 25.6870723 23.3526085 25.188027 23.3526085"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-110",
    fill: "#000000",
    points: "24.1912395 25.8093814 24.6902847 25.8093814 24.6902847 24.8277002 24.1912395 24.8277002"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-111",
    fill: "#000000",
    points: "22.6941036 24.8277002 24.1912395 24.8277002 24.1912395 24.3342897 22.6941036 24.3342897"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-112",
    fill: "#000000",
    points: "21.1930588 24.8277002 21.6934071 24.8277002 21.6934071 24.3317199 21.1930588 24.3317199"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-113",
    fill: "#000000",
    points: "20.1962712 25.3185408 22.6928006 25.3185408 22.6928006 24.8264153 20.1962712 24.8264153"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-114",
    fill: "#000000",
    points: "20.1962712 24.83027 20.6953165 24.83027 20.6953165 23.8434491 20.1962712 23.8434491"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-115",
    fill: "#000000",
    points: "19.6985289 24.8277002 20.1975742 24.8277002 20.1975742 24.3317199 19.6985289 24.3317199"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-116",
    fill: "#000000",
    points: "21.6947101 24.3317199 22.1937553 24.3317199 22.1937553 22.8566282 21.6947101 22.8566282"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-117",
    fill: "#000000",
    points: "20.6953165 21.8710922 21.1943618 21.8710922 21.1943618 21.3789666 20.6953165 21.3789666"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-118",
    fill: "#000000",
    points: "21.6934071 21.3802516 22.1924523 21.3802516 22.1924523 20.8868411 21.6934071 20.8868411"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-119",
    fill: "#000000",
    points: "21.1930588 22.8579131 21.6934071 22.8579131 21.6934071 20.8855562 21.1930588 20.8855562"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-120",
    fill: "#000000",
    points: "22.1937553 23.844734 23.6908912 23.844734 23.6908912 23.3526085 22.1937553 23.3526085"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-121",
    fill: "#000000",
    points: "23.1905429 22.859198 23.6908912 22.859198 23.6908912 22.3670725 23.1905429 22.3670725"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-122",
    fill: "#000000",
    points: "23.6908912 23.3526085 24.1899365 23.3526085 24.1899365 22.3632177 23.6908912 22.3632177"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-123",
    fill: "#000000",
    points: "22.6941036 22.3645026 23.1931489 22.3645026 23.1931489 21.8723771 22.6941036 21.8723771"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-124",
    fill: "#000000",
    points: "24.1912395 22.3645026 24.6902847 22.3645026 24.6902847 21.8723771 24.1912395 21.8723771"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-125",
    fill: "#000000",
    points: "23.6908912 21.8723771 24.1899365 21.8723771 24.1899365 21.3802516 23.6908912 21.3802516"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-126",
    fill: "#000000",
    points: "24.6889817 21.8723771 25.188027 21.8723771 25.188027 21.3802516 24.6889817 21.3802516"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-127",
    fill: "#000000",
    points: "24.1912395 21.3815365 25.6870723 21.3815365 25.6870723 20.889411 24.1912395 20.889411"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-128",
    fill: "#000000",
    points: "26.1861176 25.3185408 26.6877689 25.3185408 26.6877689 24.3330048 26.1861176 24.3330048"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-129",
    fill: "#000000",
    points: "22.6901946 26.7949174 23.6934972 26.7949174 23.6934972 26.3027919 22.6901946 26.3027919"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-130",
    fill: "#000000",
    points: "22.1937553 28.7659894 22.6928006 28.7659894 22.6928006 26.7936325 22.1937553 26.7936325"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-131",
    fill: "#000000",
    points: "25.6883753 26.3066466 26.6890718 26.3066466 26.6890718 25.8119513 25.6883753 25.8119513"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-132",
    fill: "#000000",
    points: "25.6883753 27.287043 26.1874206 27.287043 26.1874206 26.3053617 25.6883753 26.3053617"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-133",
    fill: "#000000",
    points: "20.6953165 29.2555451 23.1879369 29.2555451 23.1879369 28.7659894 20.6953165 28.7659894"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-134",
    fill: "#000000",
    points: "21.1930588 28.7659894 21.6934071 28.7659894 21.6934071 28.271294 21.1930588 28.271294"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-135",
    fill: "#000000",
    points: "21.6947101 30.7319217 27.1881171 30.7319217 27.1881171 30.2397962 21.6947101 30.2397962"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-136",
    fill: "#000000",
    points: "29.6820405 30.7319217 35.1728416 30.7319217 35.1728416 30.2372263 29.6820405 30.2372263"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-137",
    fill: "#000000",
    points: "18.7004384 27.7804534 19.1994837 27.7804534 19.1994837 20.3972854 18.7004384 20.3972854"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-138",
    fill: "#000000",
    points: "37.669371 27.7804534 38.1684163 27.7804534 38.1684163 20.3972854 37.669371 20.3972854"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-139",
    fill: "#000000",
    points: "26.6877689 23.3474688 28.1822987 23.3474688 28.1822987 22.8566282 26.6877689 22.8566282"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-140",
    fill: "#000000",
    points: "28.68395 23.3474688 30.1797828 23.3474688 30.1797828 22.8566282 28.68395 22.8566282"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-141",
    fill: "#000000",
    points: "18.7004384 19.9051599 19.1994837 19.9051599 19.1994837 14.491779 18.7004384 14.491779"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-142",
    fill: "#000000",
    points: "31.6822609 7.10629809 32.6777455 7.10629809 32.6777455 6.61417255 33.1767908 6.61417255 33.1767908 7.10629809 33.6771391 7.10629809 33.6771391 7.59842363 33.1767908 7.59842363 33.1767908 8.09311902 32.6777455 8.09311902 32.6777455 7.59842363 31.6822609 7.59842363"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-143",
    fill: "#000000",
    points: "35.1724507 7.10629809 35.1724507 7.59842363 35.674102 7.59842363 35.674102 8.09311902 36.1705413 8.09311902 36.1705413 7.10629809"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-144",
    fill: "#000000",
    points: "35.6743626 6.12333194 35.6743626 6.61545748 36.1721049 6.61545748 36.1721049 7.10629809 36.6685442 7.10629809 36.6685442 6.12333194"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-145",
    fill: "#000000",
    points: "9.71241134 10.5522048 10.2114566 10.5522048 10.2114566 10.0600793 9.71241134 10.0600793"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-146",
    fill: "#000000",
    points: "12.709289 11.5364559 13.2083343 11.5364559 13.2083343 10.0613642 12.709289 10.0613642"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-147",
    fill: "#000000",
    points: "12.709289 12.520707 13.2083343 12.520707 13.2083343 12.0285814 12.709289 12.0285814"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-148",
    fill: "#000000",
    points: "14.7054701 12.520707 15.2045154 12.520707 15.2045154 12.0285814 14.7054701 12.0285814"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-149",
    fill: "#000000",
    points: "14.2077278 13.506243 14.7067731 13.506243 14.7067731 12.520707 14.2077278 12.520707"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-150",
    fill: "#000000",
    points: "15.2045154 15.4747451 15.7035607 15.4747451 15.7035607 14.490494 15.2045154 14.490494"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-151",
    fill: "#000000",
    points: "16.206515 14.9839045 16.7042572 14.9839045 16.7042572 14.491779 16.206515 14.491779"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-152",
    fill: "#000000",
    points: "16.7029543 14.491779 17.7049538 14.491779 17.7049538 13.9983685 16.7029543 13.9983685"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-153",
    fill: "#000000",
    points: "17.7036508 13.9996534 18.2013931 13.9996534 18.2013931 12.520707 17.7036508 12.520707"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-154",
    fill: "#000000",
    points: "11.7125014 8.58241772 12.2102437 8.58241772 12.2102437 8.09029218 11.7125014 8.09029218"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-155",
    fill: "#000000",
    points: "13.2083343 7.10604111 13.7073796 7.10604111 13.7073796 6.61391557 13.2083343 6.61391557"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-156",
    fill: "#000000",
    points: "10.2114566 6.61391557 11.2134562 6.61391557 11.2134562 6.12179003 10.2114566 6.12179003"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-157",
    fill: "#000000",
    points: "9.71241134 7.10604111 10.2114566 7.10604111 10.2114566 6.61391557 9.71241134 6.61391557"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-158",
    fill: "#000000",
    points: "8.71562377 11.0456153 9.21466905 11.0456153 9.21466905 10.5534897 8.71562377 10.5534897"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-159",
    fill: "#000000",
    points: "9.21466905 12.5232768 9.71371433 12.5232768 9.71371433 11.0456153 9.21466905 11.0456153"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-160",
    fill: "#000000",
    points: "8.71562377 15.4747451 9.21466905 15.4747451 9.21466905 14.490494 8.71562377 14.490494"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-161",
    fill: "#000000",
    points: "9.21466905 16.9498368 9.71371433 16.9498368 9.71371433 15.4747451 9.21466905 15.4747451"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-162",
    fill: "#000000",
    points: "9.21466905 18.918339 9.71371433 18.918339 9.71371433 17.4432473 9.21466905 17.4432473"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-163",
    fill: "#000000",
    points: "8.71562377 17.9379426 9.21466905 17.9379426 9.21466905 16.9485519 8.71562377 16.9485519"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-164",
    fill: "#000000",
    points: "8.71562377 19.4091796 9.21466905 19.4091796 9.21466905 18.917054 8.71562377 18.917054"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-165",
    fill: "#000000",
    points: "8.71562377 21.3815365 9.21466905 21.3815365 9.21466905 20.889411 8.71562377 20.889411"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-166",
    fill: "#000000",
    points: "8.21788148 19.9051599 8.71692676 19.9051599 8.71692676 19.4117494 8.21788148 19.4117494"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-167",
    fill: "#000000",
    points: "9.21466905 20.888126 9.71371433 20.888126 9.71371433 19.903875 9.21466905 19.903875"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-168",
    fill: "#000000",
    points: "8.21788148 21.8723771 8.71692676 21.8723771 8.71692676 21.3802516 8.21788148 21.3802516"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-169",
    fill: "#000000",
    points: "7.7175332 20.3972854 8.21657849 20.3972854 8.21657849 19.9051599 7.7175332 19.9051599"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-170",
    fill: "#000000",
    points: "7.21718493 20.888126 7.71623021 20.888126 7.71623021 20.3972854 7.21718493 20.3972854"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-171",
    fill: "#000000",
    points: "6.72074563 21.3815365 7.21979091 21.3815365 7.21979091 20.889411 6.72074563 20.889411"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-172",
    fill: "#000000",
    points: "6.21779138 21.8723771 6.71944264 21.8723771 6.71944264 21.3802516 6.21779138 21.3802516"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-173",
    fill: "#000000",
    points: "5.72004909 22.3645026 6.22170035 22.3645026 6.22170035 21.8723771 5.72004909 21.8723771"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-174",
    fill: "#000000",
    points: "6.72074563 22.859198 7.21979091 22.859198 7.21979091 22.3670725 6.72074563 22.3670725"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-175",
    fill: "#000000",
    points: "7.21979091 22.3645026 8.21788148 22.3645026 8.21788148 21.8723771 7.21979091 21.8723771"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-176",
    fill: "#000000",
    points: "5.21970082 22.859198 5.72265507 22.859198 5.72265507 22.3670725 5.21970082 22.3670725"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-177",
    fill: "#000000",
    points: "4.72195852 23.3526085 5.21970082 23.3526085 5.21970082 22.859198 4.72195852 22.859198"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-178",
    fill: "#000000",
    points: "2.22673212 23.844734 4.72195852 23.844734 4.72195852 23.3526085 2.22673212 23.3526085"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-179",
    fill: "#000000",
    points: "1.22864155 23.844734 1.72768683 23.844734 1.72768683 23.3526085 1.22864155 23.3526085"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-180",
    fill: "#000000",
    points: "1.72768683 24.3330048 2.22673212 24.3330048 2.22673212 23.8421642 1.72768683 23.8421642"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-181",
    fill: "#000000",
    points: "1.72768683 23.3526085 2.22673212 23.3526085 2.22673212 21.3802516 1.72768683 21.3802516"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-182",
    fill: "#000000",
    points: "0.726990291 23.3526085 1.22864155 23.3526085 1.22864155 21.3802516 0.726990291 21.3802516"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-183",
    fill: "#000000",
    points: "1.72768683 29.258115 2.22673212 29.258115 2.22673212 28.272579 1.72768683 28.272579"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-184",
    fill: "#000000",
    points: "1.22864155 21.3815365 1.72768683 21.3815365 1.72768683 20.889411 1.22864155 20.889411"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-185",
    fill: "#000000",
    points: "2.22673212 21.3815365 2.7257774 21.3815365 2.7257774 20.889411 2.22673212 20.889411"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-186",
    fill: "#000000",
    points: "2.22673212 20.3972854 2.7257774 20.3972854 2.7257774 19.9051599 2.22673212 19.9051599"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-187",
    fill: "#000000",
    points: "1.72768683 20.888126 2.22673212 20.888126 2.22673212 20.3972854 1.72768683 20.3972854"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-188",
    fill: "#000000",
    points: "2.72708039 20.888126 3.22612567 20.888126 3.22612567 20.3972854 2.72708039 20.3972854"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-189",
    fill: "#000000",
    points: "2.72708039 19.9051599 3.22612567 19.9051599 3.22612567 19.4117494 2.72708039 19.4117494"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-190",
    fill: "#000000",
    points: "3.22482268 20.3972854 3.72386796 20.3972854 3.72386796 19.9051599 3.22482268 19.9051599"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-191",
    fill: "#000000",
    points: "2.22673212 19.4104645 2.7257774 19.4104645 2.7257774 18.4313531 2.22673212 18.4313531"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-192",
    fill: "#000000",
    points: "3.72386796 20.888126 4.72326151 20.888126 4.72326151 20.3972854 3.72386796 20.3972854"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-193",
    fill: "#000000",
    points: "4.72195852 20.3972854 5.72265507 20.3972854 5.72265507 19.9051599 4.72195852 19.9051599"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-194",
    fill: "#000000",
    points: "5.72004909 17.4445322 6.22170035 17.4445322 6.22170035 16.9498368 5.72004909 16.9498368"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-195",
    fill: "#000000",
    points: "5.21970082 17.9379426 5.72265507 17.9379426 5.72265507 14.9839045 5.21970082 14.9839045"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-196",
    fill: "#000000",
    points: "2.72708039 17.4445322 3.22612567 17.4445322 3.22612567 16.9498368 2.72708039 16.9498368"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-197",
    fill: "#000000",
    points: "3.22482268 15.477315 4.22291324 15.477315 4.22291324 14.9839045 3.22482268 14.9839045"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-198",
    fill: "#000000",
    points: "2.72708039 14.9839045 3.22612567 14.9839045 3.22612567 12.520707 2.72708039 12.520707"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-199",
    fill: "#000000",
    points: "3.72386796 13.9996534 4.22291324 13.9996534 4.22291324 13.0141174 3.72386796 13.0141174"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-200",
    fill: "#000000",
    points: "4.72195852 13.506243 5.21970082 13.506243 5.21970082 12.0298663 4.72195852 12.0298663"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-201",
    fill: "#000000",
    points: "3.72386796 12.0285814 4.22291324 12.0285814 4.22291324 11.5364559 3.72386796 11.5364559"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-202",
    fill: "#000000",
    points: "3.22482268 12.520707 3.72386796 12.520707 3.72386796 12.0285814 3.22482268 12.0285814"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-203",
    fill: "#000000",
    points: "2.22673212 25.3185408 2.7257774 25.3185408 2.7257774 24.330435 2.22673212 24.330435"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-204",
    fill: "#000000",
    points: "2.72708039 25.8093814 3.22612567 25.8093814 3.22612567 25.3185408 2.72708039 25.3185408"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-205",
    fill: "#000000",
    points: "3.22482268 25.3185408 4.22291324 25.3185408 4.22291324 24.8264153 3.22482268 24.8264153"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-206",
    fill: "#000000",
    points: "3.72386796 26.7949174 4.22291324 26.7949174 4.22291324 26.3027919 3.72386796 26.3027919"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-207",
    fill: "#000000",
    points: "4.22291324 24.8277002 4.72195852 24.8277002 4.72195852 24.3317199 4.22291324 24.3317199"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-208",
    fill: "#000000",
    points: "4.22291324 26.3053617 4.72195852 26.3053617 4.72195852 25.315971 4.22291324 25.315971"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-209",
    fill: "#000000",
    points: "2.72708039 27.287043 3.72517095 27.287043 3.72517095 26.7949174 2.72708039 26.7949174"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-210",
    fill: "#000000",
    points: "4.22291324 27.287043 5.21970082 27.287043 5.21970082 26.7949174 4.22291324 26.7949174"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-211",
    fill: "#000000",
    points: "3.72386796 27.7843082 4.22291324 27.7843082 4.22291324 27.2921826 3.72386796 27.2921826"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-212",
    fill: "#000000",
    points: "3.22482268 28.7659894 3.72386796 28.7659894 3.72386796 27.7778836 3.22482268 27.7778836"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-213",
    fill: "#000000",
    points: "2.22673212 28.272579 2.7257774 28.272579 2.7257774 27.285758 2.22673212 27.285758"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-214",
    fill: "#000000",
    points: "10.2153656 17.4445322 10.7144109 17.4445322 10.7144109 16.9498368 10.2153656 16.9498368"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-215",
    fill: "#000000",
    points: "11.2121532 18.4313531 11.7111984 18.4313531 11.7111984 17.9353728 11.2121532 17.9353728"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-216",
    fill: "#000000",
    points: "10.7131079 18.9221937 11.2121532 18.9221937 11.2121532 18.4313531 10.7131079 18.4313531"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-217",
    fill: "#000000",
    points: "11.7125014 17.9353728 12.2102437 17.9353728 12.2102437 17.4432473 11.7125014 17.4432473"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-218",
    fill: "#000000",
    points: "10.7131079 17.9353728 11.2121532 17.9353728 11.2121532 17.4432473 10.7131079 17.4432473"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-219",
    fill: "#000000",
    points: "2.22673212 29.7489556 2.7257774 29.7489556 2.7257774 29.2555451 2.22673212 29.2555451"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-220",
    fill: "#000000",
    points: "2.72708039 31.2253322 3.22612567 31.2253322 3.22612567 29.7502405 2.72708039 29.7502405"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-221",
    fill: "#000000",
    points: "3.22482268 31.7161728 3.72386796 31.7161728 3.72386796 31.2240473 3.22482268 31.2240473"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-222",
    fill: "#000000",
    points: "5.71913699 30.7321787 5.71913699 31.2243042 6.21818228 31.2243042 6.21818228 31.7164298 3.72295587 31.7164298 3.72295587 32.2085553 7.71922709 32.2085553 7.71922709 31.7164298 6.7250455 31.7164298 6.7250455 31.2243042 7.71922709 31.2243042 7.71922709 30.7321787"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-223",
    fill: "#000000",
    points: "5.21970082 30.7319217 5.72265507 30.7319217 5.72265507 30.2397962 5.21970082 30.2397962"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-224",
    fill: "#000000",
    points: "4.72195852 30.2410811 5.21970082 30.2410811 5.21970082 28.7659894 4.72195852 28.7659894"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-225",
    fill: "#000000",
    points: "5.21970082 28.7659894 5.72265507 28.7659894 5.72265507 28.2738639 5.21970082 28.2738639"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-226",
    fill: "#000000",
    points: "5.72004909 28.272579 6.72204862 28.272579 6.72204862 27.7804534 5.72004909 27.7804534"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-227",
    fill: "#000000",
    points: "6.72074563 27.7804534 7.21979091 27.7804534 7.21979091 27.2883279 6.72074563 27.2883279"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-228",
    fill: "#000000",
    points: "7.7175332 31.7161728 8.21657849 31.7161728 8.21657849 31.2240473 7.7175332 31.2240473"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-229",
    fill: "#000000",
    points: "8.21788148 32.2082983 8.71692676 32.2082983 8.71692676 31.7161728 8.21788148 31.7161728"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-230",
    fill: "#000000",
    points: "7.7175332 30.7319217 8.71562377 30.7319217 8.71562377 30.2397962 7.7175332 30.2397962"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-231",
    fill: "#000000",
    points: "7.21718493 27.287043 7.71623021 27.287043 7.71623021 26.7949174 7.21718493 26.7949174"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-232",
    fill: "#000000",
    points: "7.7175332 27.7804534 9.71501732 27.7804534 9.71501732 27.2883279 7.7175332 27.2883279"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-233",
    fill: "#000000",
    points: "10.2114566 25.3185408 10.7118049 25.3185408 10.7118049 24.8264153 10.2114566 24.8264153"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-234",
    fill: "#000000",
    points: "9.71241134 28.272579 10.2114566 28.272579 10.2114566 27.7804534 9.71241134 27.7804534"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-235",
    fill: "#000000",
    points: "9.71241134 27.287043 10.2114566 27.287043 10.2114566 26.7949174 9.71241134 26.7949174"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-236",
    fill: "#000000",
    points: "8.71562377 26.7949174 9.71501732 26.7949174 9.71501732 26.3027919 8.71562377 26.3027919"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-237",
    fill: "#000000",
    points: "7.21718493 25.8093814 7.71623021 25.8093814 7.71623021 24.8277002 7.21718493 24.8277002"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-238",
    fill: "#000000",
    points: "6.72074563 24.8277002 7.21979091 24.8277002 7.21979091 24.3317199 6.72074563 24.3317199"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-239",
    fill: "#000000",
    points: "5.21970082 26.7949174 5.72265507 26.7949174 5.72265507 26.3027919 5.21970082 26.3027919"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-240",
    fill: "#000000",
    points: "10.7105019 25.8093814 11.2121532 25.8093814 11.2121532 25.3185408 10.7105019 25.3185408"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-241",
    fill: "#000000",
    points: "11.7125014 27.287043 12.2102437 27.287043 12.2102437 26.7949174 11.7125014 26.7949174"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-242",
    fill: "#000000",
    points: "11.2095472 26.7974873 11.7125014 26.7974873 11.7125014 25.8093814 11.2095472 25.8093814"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-243",
    fill: "#000000",
    points: "12.2076377 27.7804534 12.709289 27.7804534 12.709289 27.2883279 12.2076377 27.2883279"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-244",
    fill: "#000000",
    points: "12.709289 28.272579 13.2083343 28.272579 13.2083343 27.7804534 12.709289 27.7804534"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-245",
    fill: "#000000",
    points: "13.2083343 29.258115 13.7073796 29.258115 13.7073796 28.272579 13.2083343 28.272579"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-246",
    fill: "#000000",
    points: "12.709289 29.7489556 13.2083343 29.7489556 13.2083343 29.2555451 12.709289 29.2555451"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-247",
    fill: "#000000",
    points: "14.2077278 31.7161728 14.7067731 31.7161728 14.7067731 31.2240473 14.2077278 31.2240473"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-248",
    fill: "#000000",
    points: "19.1981807 32.2082983 19.6972259 32.2082983 19.6972259 31.7161728 19.1981807 31.7161728"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-249",
    fill: "#000000",
    points: "18.7004384 31.7161728 19.1994837 31.7161728 19.1994837 31.2240473 18.7004384 31.2240473"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-250",
    fill: "#000000",
    points: "19.6985289 31.7200276 20.1975742 31.7200276 20.1975742 30.7319217 19.6985289 30.7319217"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-251",
    fill: "#000000",
    points: "18.7004384 30.7319217 19.6985289 30.7319217 19.6985289 30.2397962 18.7004384 30.2397962"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-252",
    fill: "#000000",
    points: "20.1962712 31.2253322 20.6953165 31.2253322 20.6953165 30.7332066 20.1962712 30.7332066"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-253",
    fill: "#000000",
    points: "16.7029543 30.7319217 17.2019995 30.7319217 17.2019995 30.2397962 16.7029543 30.2397962"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-254",
    fill: "#000000",
    points: "17.2019995 31.7200276 17.7023478 31.7200276 17.7023478 30.7319217 17.2019995 30.7319217"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-255",
    fill: "#000000",
    points: "16.206515 30.2410811 16.7042572 30.2410811 16.7042572 29.7489556 16.206515 29.7489556"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-256",
    fill: "#000000",
    points: "14.2077278 29.7489556 14.7067731 29.7489556 14.7067731 28.2738639 14.2077278 28.2738639"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-257",
    fill: "#000000",
    points: "15.7035607 29.7489556 16.206515 29.7489556 16.206515 26.7949174 15.7035607 26.7949174"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-258",
    fill: "#000000",
    points: "16.206515 26.7949174 16.7042572 26.7949174 16.7042572 26.3027919 16.206515 26.3027919"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-259",
    fill: "#000000",
    points: "16.7029543 27.287043 17.7049538 27.287043 17.7049538 26.7949174 16.7029543 26.7949174"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-260",
    fill: "#000000",
    points: "17.7036508 27.7804534 18.2013931 27.7804534 18.2013931 25.8093814 17.7036508 25.8093814"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-261",
    fill: "#000000",
    points: "16.7029543 25.8093814 17.7049538 25.8093814 17.7049538 25.3185408 16.7029543 25.3185408"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-262",
    fill: "#000000",
    points: "14.7054701 24.8277002 15.2045154 24.8277002 15.2045154 24.3317199 14.7054701 24.3317199"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-263",
    fill: "#000000",
    points: "15.2045154 25.3185408 16.7016513 25.3185408 16.7016513 24.8264153 15.2045154 24.8264153"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-264",
    fill: "#000000",
    points: "15.2045154 25.3185408 15.7035607 25.3185408 15.7035607 24.8264153 15.2045154 24.8264153"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-265",
    fill: "#000000",
    points: "13.7073796 24.3330048 14.7054701 24.3330048 14.7054701 23.8421642 13.7073796 23.8421642"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-266",
    fill: "#000000",
    points: "13.2083343 23.844734 13.7073796 23.844734 13.7073796 23.3526085 13.2083343 23.3526085"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-267",
    fill: "#000000",
    points: "12.2076377 23.3526085 13.2096373 23.3526085 13.2096373 22.859198 12.2076377 22.859198"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-268",
    fill: "#000000",
    points: "14.2077278 20.888126 15.2058184 20.888126 15.2058184 20.3972854 14.2077278 20.3972854"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-269",
    fill: "#000000",
    points: "15.2045154 21.3815365 15.7035607 21.3815365 15.7035607 20.889411 15.2045154 20.889411"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-270",
    fill: "#000000",
    points: "15.7035607 20.888126 16.206515 20.888126 16.206515 20.3972854 15.7035607 20.3972854"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-271",
    fill: "#000000",
    points: "16.206515 21.3815365 18.2000901 21.3815365 18.2000901 20.889411 16.206515 20.889411"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-272",
    fill: "#000000",
    points: "18.2000901 20.888126 18.6991354 20.888126 18.6991354 20.3972854 18.2000901 20.3972854"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-273",
    fill: "#000000",
    points: "18.2000901 21.8723771 18.6991354 21.8723771 18.6991354 21.3802516 18.2000901 21.3802516"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-274",
    fill: "#000000",
    points: "12.2089407 17.4445322 12.707986 17.4445322 12.707986 16.9498368 12.2089407 16.9498368"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-275",
    fill: "#000000",
    points: "13.2083343 19.4091796 13.7073796 19.4091796 13.7073796 18.917054 13.2083343 18.917054"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-276",
    fill: "#000000",
    points: "14.2077278 17.4445322 14.7067731 17.4445322 14.7067731 16.9498368 14.2077278 16.9498368"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-277",
    fill: "#000000",
    points: "12.2089407 14.9839045 13.2083343 14.9839045 13.2083343 14.491779 12.2089407 14.491779"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-278",
    fill: "#000000",
    points: "14.7054701 17.9353728 15.2071214 17.9353728 15.2071214 17.4432473 14.7054701 17.4432473"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-279",
    fill: "#000000",
    points: "15.2045154 18.4313531 16.2078179 18.4313531 16.2078179 17.9353728 15.2045154 17.9353728"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-280",
    fill: "#000000",
    points: "16.206515 18.9221937 16.7042572 18.9221937 16.7042572 18.4313531 16.206515 18.4313531"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-281",
    fill: "#000000",
    points: "17.7036508 19.9051599 18.2013931 19.9051599 18.2013931 18.4300682 17.7036508 18.4300682"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-282",
    fill: "#000000",
    points: "16.7029543 19.4091796 17.2019995 19.4091796 17.2019995 18.917054 16.7029543 18.917054"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-283",
    fill: "#000000",
    points: "17.2019995 19.9051599 17.7023478 19.9051599 17.7023478 19.4117494 17.2019995 19.4117494"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-284",
    fill: "#000000",
    points: "18.2000901 18.4313531 18.6991354 18.4313531 18.6991354 17.9353728 18.2000901 17.9353728"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-285",
    fill: "#000000",
    points: "18.2000901 16.4577113 18.6991354 16.4577113 18.6991354 15.9655857 18.2000901 15.9655857"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-286",
    fill: "#000000",
    points: "18.2000901 15.477315 18.6991354 15.477315 18.6991354 14.9839045 18.2000901 14.9839045"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-287",
    fill: "#000000",
    points: "15.2038639 16.4583537 15.2038639 17.4451746 16.7009998 17.4451746 16.7009998 16.9491943 16.2071664 16.9491943 16.2071664 16.4583537"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-288",
    fill: "#000000",
    points: "16.202606 16.4577113 17.2019995 16.4577113 17.2019995 15.9655857 16.202606 15.9655857"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-289",
    fill: "#000000",
    points: "17.2019995 15.9668706 18.2000901 15.9668706 18.2000901 15.4747451 17.2019995 15.4747451"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-290",
    fill: "#000000",
    points: "14.704558 13.9957986 15.7026486 13.9957986 15.7026486 14.490494 16.2016939 14.490494 16.2016939 13.0141174 15.7026486 13.0141174 15.7026486 13.504958 14.704558 13.504958"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-291",
    fill: "#000000",
    points: "13.2091161 14.9827481 13.2091161 16.9499653 14.2072066 16.9499653 14.2072066 16.4565548 13.7068584 16.4565548 13.7068584 15.4735887 14.2072066 15.4735887 14.2072066 14.9827481"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.210329,12.5189081 L11.7119802,12.5189081 L11.7119802,11.5359419 L11.210329,11.5359419 L11.210329,11.0451013 L10.7112837,11.0451013 L10.7112837,12.0280674 L11.210329,12.0280674 L11.210329,12.5189081 Z M12.2097225,10.5529758 L12.2097225,11.5359419 L12.7061618,11.5359419 L12.7061618,12.0280674 L12.2097225,12.0280674 L12.2097225,12.5189081 L11.7119802,12.5189081 L11.7119802,13.0148884 L10.7112837,13.0148884 L10.7112837,12.5189081 L10.2122384,12.5189081 L10.2122384,10.5529758 L12.2097225,10.5529758 Z",
    id: "Fill-292",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-293",
    fill: "#000000",
    points: "8.71419048 30.7321787 8.71419048 31.7164298 9.21453875 31.7164298 9.21453875 32.2085553 10.2113263 32.2085553 10.2113263 31.2255892 9.71488702 31.2255892 9.71488702 30.7321787"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-294",
    fill: "#000000",
    points: "20.6955771 31.2248182 20.6955771 31.7169438 20.1965318 31.7169438 20.1965318 32.2090693 21.1946224 32.2090693 21.1946224 31.2248182"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-295",
    fill: "#000000",
    points: "4.22265264 13.9957986 5.21944022 13.9957986 5.21944022 13.504958 5.7184855 13.504958 5.7184855 14.490494 5.21944022 14.490494 5.21944022 14.9826196 4.72169793 14.9826196 4.72169793 14.490494 4.22265264 14.490494"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-296",
    fill: "#000000",
    points: "5.71913699 10.0607217 5.22009171 10.0607217 5.22009171 11.0449728 4.22330414 11.0449728 4.22330414 11.5358134 5.22009171 11.5358134 5.22009171 12.027939 5.71913699 12.027939"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-297",
    fill: "#000000",
    points: "8.71510257 7.10629809 9.71449612 7.10629809 9.71449612 7.59842363 9.21414785 7.59842363 9.21414785 8.09311902 8.71510257 8.09311902 8.71510257 10.5524618 8.21736028 10.5524618 8.21736028 8.09054917 7.718315 8.09054917 7.718315 7.59842363 8.71510257 7.59842363"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-298",
    fill: "#000000",
    points: "9.21492965 8.58190375 9.21492965 9.56872468 9.71267194 9.56872468 9.71267194 9.07788406 10.2117172 9.07788406 10.2117172 8.58190375"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-299",
    fill: "#000000",
    points: "9.21492965 13.9963126 9.21492965 14.491008 9.71267194 14.491008 9.71267194 14.9844185 10.2117172 14.9844185 10.2117172 13.9963126"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-300",
    fill: "#000000",
    points: "12.2146739 16.9498368 12.2146739 17.4445322 12.7059012 17.4445322 12.7059012 17.9340879 13.2088555 17.9340879 13.2088555 16.9498368"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-301",
    fill: "#000000",
    points: "13.7030797 7.59880911 13.7082917 8.58177526 13.2092464 8.58177526 13.2092464 8.08964972 12.7062921 8.08964972 12.7062921 7.59880911 11.7121105 7.59880911 11.7121105 7.10668357 11.2130653 7.10668357 11.2130653 6.61327311 12.2098528 6.61327311 12.2098528 7.10668357 13.2092464 7.10668357 13.2092464 7.59880911"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-302",
    fill: "#000000",
    points: "12.2098528 8.0900352 12.2098528 9.07942597 11.2104593 9.07942597 11.2104593 10.063677 10.2123687 10.063677 10.2123687 9.56641182 10.71402 9.56641182 10.71402 9.07814105 11.2104593 9.07814105 11.2104593 8.58216074 11.7121105 8.58216074 11.7121105 8.0900352"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-303",
    fill: "#000000",
    points: "52.6329115 26.7949174 53.1358658 26.7949174 53.1358658 26.3027919 52.6329115 26.3027919"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-304",
    fill: "#000000",
    points: "17.6984388 31.2253322 18.7017414 31.2253322 18.7017414 30.7332066 17.6984388 30.7332066"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-305",
    fill: "#000000",
    points: "18.7000475 1.6924032 20.1971833 1.6924032 20.1971833 2.18581366 20.6962286 2.18581366 20.6962286 3.16492505 21.1939709 3.16749489 21.1939709 3.6634752 21.6956222 3.65962043 21.6956222 4.64772628 21.1887589 4.64772628 21.1887589 5.13856689 20.6962286 5.13856689 20.6962286 4.64772628 21.1939709 4.64772628 21.1939709 3.65962043 20.1971833 3.65962043 20.1971833 2.18581366 19.1977898 2.18581366 19.1977898 2.67665428 19.700744 2.67665428 19.698138 3.65962043 20.1971833 3.65962043 20.1971833 5.13856689 19.698138 5.13856689 19.698138 3.65962043 19.1977898 3.6634752 19.1977898 2.67665428 18.7000475 2.67665428"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-306",
    fill: "#000000",
    points: "22.1942765 2.18568517 22.1942765 4.15804209 23.1936701 4.15033255 23.1936701 3.66077686 22.6920188 3.66077686 22.6920188 2.18568517"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-307",
    fill: "#000000",
    points: "23.1934095 1.20040615 23.1934095 1.69253169 24.6879394 1.69253169 24.6918483 1.20040615"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-308",
    fill: "#000000",
    points: "20.1971833 6.12333194 20.1971833 7.10629809 20.6949256 7.10629809 20.6949256 6.61802732 21.1939709 6.61545748 21.1939709 6.12333194"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-309",
    fill: "#000000",
    points: "20.6955771 7.10629809 20.6955771 8.09311902 21.1946224 8.09311902 21.1946224 7.60099348 21.6949707 7.60099348 21.6949707 7.10629809"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-310",
    fill: "#000000",
    points: "26.6877689 4.64798326 27.6858594 4.64798326 27.6858594 4.15585772 26.6877689 4.15585772"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-311",
    fill: "#000000",
    points: "26.6892021 1.20040615 26.6892021 2.67678277 27.1882474 2.67678277 27.1830355 1.69253169 27.6898987 1.69253169 27.6898987 1.20040615"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-312",
    fill: "#000000",
    points: "29.177653 1.20040615 29.177653 1.69253169 29.6727893 1.69253169 29.6766983 2.67678277 30.1783495 2.67678277 30.1809555 4.15572923 30.6826068 4.15572923 30.6826068 2.18594215 30.1783495 2.19108185 30.1783495 1.20040615"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-313",
    fill: "#000000",
    points: "29.1777833 4.64798326 30.1784798 4.64798326 30.1784798 4.15585772 29.1777833 4.15585772"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-314",
    fill: "#000000",
    points: "32.1850849 1.69266018 33.6691908 1.69266018 33.6691908 1.20053465 32.1850849 1.20053465"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-315",
    fill: "#000000",
    points: "34.1744905 2.18568517 34.1744905 3.66077686 33.6637183 3.66077686 33.6637183 4.15033255 34.6618088 4.15804209 34.6618088 2.18568517"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-316",
    fill: "#000000",
    points: "38.1691981 1.6924032 36.6720623 1.6924032 36.6720623 2.18581366 36.173017 2.18581366 36.173017 3.16492505 35.6739717 3.16749489 35.6739717 3.6634752 35.1749264 3.65962043 35.1749264 4.64772628 35.6791837 4.64772628 35.6791837 5.13856689 36.173017 5.13856689 36.173017 4.64772628 35.6739717 4.64772628 35.6739717 3.65962043 36.6720623 3.65962043 36.6720623 2.18581366 37.6701528 2.18581366 37.6701528 2.67665428 37.1698046 2.67665428 37.1698046 3.65962043 36.6720623 3.65962043 36.6720623 5.13856689 37.1698046 5.13856689 37.1698046 3.65962043 37.6701528 3.6634752 37.6701528 2.67665428 38.1691981 2.67665428"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-317",
    fill: "#000000",
    points: "13.7075099 19.409565 13.7009949 19.9081152 11.7074198 19.9081152 11.7126317 19.409565 11.2096775 19.409565 11.2096775 20.3976709 14.2065552 20.3976709 14.2065552 19.409565"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-318",
    fill: "#000000",
    points: "8.21579669 24.3313344 8.21579669 25.8102809 7.7180544 25.8102809 7.7180544 26.3049762 8.70963001 26.3049762 8.71484197 24.3313344"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-319",
    fill: "#000000",
    points: "13.2091161 29.7492126 13.2091161 30.2400532 13.7029494 30.2400532 13.7068584 31.2243042 14.2072066 31.2243042 14.2072066 29.7492126"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-320",
    fill: "#000000",
    points: "8.71510257 21.8728911 9.71449612 21.8728911 9.71449612 21.3807655 10.2148444 21.3781957 10.2122384 20.8873551 10.7138897 20.8873551 10.7138897 20.3965145 11.210329 20.3965145 11.210329 20.8873551 11.7119802 20.8873551 11.7119802 21.3807655 10.7138897 21.3807655 10.7138897 22.3650166 12.2097225 22.3650166 12.2097225 22.8584271 10.7138897 22.8584271 10.7138897 22.3650166 9.71449612 22.3650166 9.71449612 22.8584271 9.21414785 22.8584271 9.21414785 23.8426782 9.71449612 23.8426782 9.71449612 24.3309489 10.2122384 24.3309489 10.2122384 24.8282142 9.21414785 24.8282142 9.21414785 24.3309489 8.71510257 24.3309489"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-321",
    fill: "#000000",
    points: "6.22170035 17.4446607 6.72074563 17.4433758 6.72074563 19.410593 6.21909437 19.4067382 6.22170035 19.9040034 5.7187461 19.9040034 5.72917002 19.4067382 5.21970082 19.410593 5.21970082 18.9171825 6.21909437 18.9223222"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-322",
    fill: "#000000",
    points: "8.21579669 11.0451013 8.21579669 14.491265 8.71484197 14.491265 8.70963001 13.9965696 9.21519024 13.9965696 9.21519024 13.5044441 8.71484197 13.5044441 8.70963001 13.0123185 9.21519024 13.0161733 9.21519024 12.520193 8.71484197 12.520193 8.71484197 11.0451013"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-323",
    fill: "#000000",
    points: "13.2093767 9.56821071 13.70321 9.57078055 13.708422 8.58138978 14.2074672 8.58138978 14.2087702 11.0420175 14.7052095 11.0420175 14.7052095 12.0288384 14.2074672 12.0288384 14.2074672 11.5354279 13.708422 11.5354279 13.70321 10.0577664 13.2093767 10.0603362"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-324",
    fill: "#000000",
    points: "23.1898914 4.15058954 24.6922392 4.14801969 24.6935422 3.65974892 25.1847696 3.65974892 25.1886785 2.18337231 25.6929358 2.18337231 25.6929358 4.15829908 25.1847696 4.16215385 25.1847696 4.64785477 25.6877238 4.64785477 25.6929358 5.13484062 26.1828601 5.13484062 26.1854661 4.64785477 26.6884203 4.64785477 26.6897233 5.13484062 30.1778283 5.13484062 30.1739194 4.64785477 30.6794796 4.64785477 30.6846916 5.13484062 31.1785249 5.13484062 31.1785249 4.64785477 31.6775702 4.64785477 31.6775702 4.15572923 31.1785249 4.15572923 31.1785249 2.18594215 31.6775702 2.18594215 31.6775702 3.65974892 32.1779184 3.65974892 32.1779184 4.15572923 33.6633274 4.15058954 33.6763573 4.64785477 32.1779184 4.64785477 32.1779184 5.13869538 31.6827821 5.13484062 31.6775702 5.63082092 25.1886785 5.63082092 25.1847696 5.13484062 24.6935422 5.13741046 24.6922392 4.64785477 23.1898914 4.64785477"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-325",
    fill: "#000000",
    points: "31.6771793 10.5495065 30.6790887 10.5495065 30.6790887 11.0429169 30.1800434 11.0429169 30.1800434 11.5350425 30.6843007 11.526048 30.6790887 12.5192935 31.178134 12.5192935 31.178134 11.0429169 31.6771793 11.0429169"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-326",
    fill: "#000000",
    points: "29.6825617 13.5045726 30.180304 13.5045726 30.1776981 14.4952482 30.6793493 14.4913935 30.6793493 13.9954132 31.1783946 13.9992679 31.1783946 14.4952482 32.1790911 14.4913935 32.1790911 14.9822341 29.6825617 14.9822341 29.6825617 14.4913935 29.1835165 14.4913935 29.1835165 13.9954132 29.6877737 13.9954132"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-327",
    fill: "#000000",
    points: "32.6781364 12.0280674 32.6781364 12.520193 33.1758787 12.5279025 33.1758787 13.0161733 33.67753 13.0161733 33.67753 12.0280674"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-328",
    fill: "#000000",
    points: "18.2006113 12.5232768 19.1987019 12.5232768 19.1987019 10.0600793 28.1854259 10.0600793 28.1854259 16.9498368 28.6818652 16.9498368 28.6818652 10.0600793 37.6698922 10.0600793 37.6698922 12.5232768 38.6575589 12.5232768 38.6575589 12.0285814 38.1572106 12.0285814 38.1702405 9.56795372 34.6743175 9.56795372 34.6743175 9.07711311 33.673621 9.07711311 33.668409 9.56538388 23.1845492 9.56538388 23.1936701 9.07711311 22.1942765 9.07711311 22.1942765 9.56795372 18.6996566 9.56795372 18.6996566 12.0285814 18.2006113 12.0285814"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-329",
    fill: "#000000",
    points: "19.1981807 13.5045726 19.6985289 13.5045726 19.6985289 13.9992679 22.6941036 13.9954132 22.6941036 10.0609787 23.1905429 10.0609787 23.1905429 14.4913935 19.1981807 14.4913935"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-330",
    fill: "#000000",
    points: "19.1981807 15.4746166 23.1905429 15.4746166 23.1905429 19.9037465 22.6941036 19.9037465 22.6941036 15.9603175 19.1981807 15.9667422"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-331",
    fill: "#000000",
    points: "28.1873804 15.4746166 24.1937151 15.4746166 24.1937151 19.9037465 24.6927604 19.9037465 24.6927604 15.9603175 28.1873804 15.9667422"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-332",
    fill: "#000000",
    points: "28.1873804 14.4883097 24.1937151 14.4883097 24.1937151 10.0604647 24.6927604 10.0604647 24.6927604 14.0013238 28.1873804 13.9961841"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-333",
    fill: "#000000",
    points: "25.6877238 23.3510666 26.1854661 23.3510666 26.1854661 17.4429903 30.6872976 17.4365657 30.6794796 21.873405 30.1804343 21.873405 30.1804343 22.858941 30.6794796 22.858941 30.6794796 22.3642457 31.1785249 22.3642457 31.1785249 16.9495798 25.6877238 16.9495798"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-334",
    fill: "#000000",
    points: "28.6951557 25.8154206 32.6875179 25.8154206 32.6875179 30.2368409 32.1884727 30.2368409 32.1910786 26.3036913 28.6951557 26.308831"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-335",
    fill: "#000000",
    points: "37.6640288 25.8154206 33.6703635 25.8154206 33.6703635 30.2368409 34.1694088 30.2368409 34.1694088 26.3036913 37.6640288 26.308831"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-336",
    fill: "#000000",
    points: "37.6640288 24.8242309 33.6703635 24.8242309 33.6703635 20.396386 34.1694088 20.396386 34.1694088 24.33853 37.6640288 24.3308204"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-337",
    fill: "#000000",
    points: "28.6982829 24.8242309 32.6906451 24.8242309 32.6906451 20.396386 32.1942058 20.396386 32.1942058 24.33853 28.6982829 24.3308204"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-338",
    fill: "#000000",
    points: "52.6343448 15.4746166 52.1352995 15.4784714 52.1352995 17.9339594 51.6349513 17.9339594 51.6349513 18.4299397 54.1301777 18.4299397 54.1301777 17.9339594 52.6343448 17.9378142 52.6343448 16.9497083 53.6324354 16.9497083 53.6324354 16.4588677 52.6343448 16.4588677"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-339",
    fill: "#000000",
    points: "52.1351692 23.844734 54.6277897 23.844734 54.6277897 23.3526085 52.1351692 23.3526085"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-340",
    fill: "#000000",
    points: "55.1294409 23.844734 55.6284862 23.844734 55.6284862 23.3526085 55.1294409 23.3526085"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-341",
    fill: "#000000",
    points: "54.6290927 24.3330048 55.1281379 24.3330048 55.1281379 23.8421642 54.6290927 23.8421642"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-342",
    fill: "#000000",
    points: "54.6290927 23.3526085 55.1281379 23.3526085 55.1281379 21.3802516 54.6290927 21.3802516"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-343",
    fill: "#000000",
    points: "55.6297892 23.3526085 56.1288345 23.3526085 56.1288345 21.3802516 55.6297892 21.3802516"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-344",
    fill: "#000000",
    points: "55.1294409 21.3815365 55.6284862 21.3815365 55.6284862 20.889411 55.1294409 20.889411"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-345",
    fill: "#000000",
    points: "54.1300474 21.3815365 54.6277897 21.3815365 54.6277897 20.889411 54.1300474 20.889411"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-346",
    fill: "#000000",
    points: "54.1300474 20.3972854 54.6277897 20.3972854 54.6277897 19.9051599 54.1300474 19.9051599"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-347",
    fill: "#000000",
    points: "54.6290927 20.888126 55.1281379 20.888126 55.1281379 20.3972854 54.6290927 20.3972854"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-348",
    fill: "#000000",
    points: "53.6336081 20.888126 54.1313504 20.888126 54.1313504 20.3972854 53.6336081 20.3972854"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-349",
    fill: "#000000",
    points: "53.6336081 19.9051599 54.1313504 19.9051599 54.1313504 19.4117494 53.6336081 19.4117494"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-350",
    fill: "#000000",
    points: "53.1319568 20.3972854 53.6310021 20.3972854 53.6310021 19.9051599 53.1319568 19.9051599"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-351",
    fill: "#000000",
    points: "54.1300474 19.4104645 54.6277897 19.4104645 54.6277897 18.4313531 54.1300474 18.4313531"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-352",
    fill: "#000000",
    points: "52.1351692 20.888126 53.1332598 20.888126 53.1332598 20.3972854 52.1351692 20.3972854"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-353",
    fill: "#000000",
    points: "51.1331697 20.3972854 52.1364722 20.3972854 52.1364722 19.9051599 51.1331697 19.9051599"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-354",
    fill: "#000000",
    points: "50.6367304 17.4445322 51.1370787 17.4445322 51.1370787 16.9498368 50.6367304 16.9498368"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-355",
    fill: "#000000",
    points: "51.1331697 17.9379426 51.633518 17.9379426 51.633518 14.9839045 51.1331697 14.9839045"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-356",
    fill: "#000000",
    points: "53.6336081 17.4445322 54.1313504 17.4445322 54.1313504 16.9498368 53.6336081 16.9498368"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-357",
    fill: "#000000",
    points: "52.6329115 15.477315 53.6349111 15.477315 53.6349111 14.9839045 52.6329115 14.9839045"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-358",
    fill: "#000000",
    points: "53.6336081 14.9839045 54.1313504 14.9839045 54.1313504 12.520707 53.6336081 12.520707"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-359",
    fill: "#000000",
    points: "52.6329115 13.9996534 53.1319568 13.9996534 53.1319568 13.0141174 52.6329115 13.0141174"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-360",
    fill: "#000000",
    points: "51.634821 13.506243 52.1351692 13.506243 52.1351692 12.0298663 51.634821 12.0298663"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-361",
    fill: "#000000",
    points: "52.6329115 12.0285814 53.1319568 12.0285814 53.1319568 11.5364559 52.6329115 11.5364559"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-362",
    fill: "#000000",
    points: "53.1319568 12.520707 53.6310021 12.520707 53.6310021 12.0285814 53.1319568 12.0285814"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-363",
    fill: "#000000",
    points: "54.1300474 25.3185408 54.6277897 25.3185408 54.6277897 24.330435 54.1300474 24.330435"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-364",
    fill: "#000000",
    points: "53.6336081 25.8093814 54.1313504 25.8093814 54.1313504 25.3185408 53.6336081 25.3185408"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-365",
    fill: "#000000",
    points: "52.6329115 25.3185408 53.6349111 25.3185408 53.6349111 24.8264153 52.6329115 24.8264153"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-366",
    fill: "#000000",
    points: "52.6343448 13.9957986 51.6349513 13.9957986 51.6349513 13.504958 51.138512 13.504958 51.138512 14.490494 51.6349513 14.490494 51.6349513 14.9826196 52.1352995 14.9826196 52.1352995 14.490494 52.6343448 14.490494"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-367",
    fill: "#000000",
    points: "51.1335606 10.0607217 51.6339089 10.0607217 51.6339089 11.0449728 52.6333024 11.0449728 52.6333024 11.5358134 51.6339089 11.5358134 51.6339089 12.027939 51.1335606 12.027939"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-368",
    fill: "#000000",
    points: "50.6366001 17.4446607 50.1375548 17.4433758 50.1375548 19.410593 50.6379031 19.4067382 50.6366001 19.9040034 51.1343424 19.9040034 51.1317364 19.4067382 51.6346907 19.410593 51.6346907 18.9171825 50.6379031 18.9223222"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-369",
    fill: "#000000",
    points: "38.1540834 32.2082983 42.1529606 32.2082983 42.1529606 31.7161728 38.1540834 31.7161728"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-370",
    fill: "#000000",
    points: "46.6404592 10.5522048 47.1421104 10.5522048 47.1421104 10.0600793 46.6404592 10.0600793"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-371",
    fill: "#000000",
    points: "43.6487935 11.5364559 44.1478388 11.5364559 44.1478388 10.0613642 43.6487935 10.0613642"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-372",
    fill: "#000000",
    points: "43.6487935 12.520707 44.1478388 12.520707 44.1478388 12.0285814 43.6487935 12.0285814"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-373",
    fill: "#000000",
    points: "41.6526123 12.520707 42.1516576 12.520707 42.1516576 12.0285814 41.6526123 12.0285814"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-374",
    fill: "#000000",
    points: "42.1529606 13.506243 42.6507029 13.506243 42.6507029 12.520707 42.1529606 12.520707"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-375",
    fill: "#000000",
    points: "41.1509611 15.4747451 41.6526123 15.4747451 41.6526123 14.490494 41.1509611 14.490494"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-376",
    fill: "#000000",
    points: "40.1528705 14.9839045 40.6519158 14.9839045 40.6519158 14.491779 40.1528705 14.491779"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-377",
    fill: "#000000",
    points: "39.15478 14.491779 40.1554765 14.491779 40.1554765 13.9983685 39.15478 13.9983685"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-378",
    fill: "#000000",
    points: "38.6557347 13.9996534 39.15478 13.9996534 39.15478 12.520707 38.6557347 12.520707"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-379",
    fill: "#000000",
    points: "44.645581 8.58241772 45.1446263 8.58241772 45.1446263 8.09029218 44.645581 8.09029218"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-380",
    fill: "#000000",
    points: "43.1471422 7.10604111 43.6474905 7.10604111 43.6474905 6.61391557 43.1471422 6.61391557"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-381",
    fill: "#000000",
    points: "45.6436716 6.61391557 46.6404592 6.61391557 46.6404592 6.12179003 45.6436716 6.12179003"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-382",
    fill: "#000000",
    points: "46.6404592 7.10604111 47.1421104 7.10604111 47.1421104 6.61391557 46.6404592 6.61391557"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-383",
    fill: "#000000",
    points: "47.6424587 11.0456153 48.141504 11.0456153 48.141504 10.5534897 47.6424587 10.5534897"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-384",
    fill: "#000000",
    points: "47.1421104 12.5232768 47.6411557 12.5232768 47.6411557 11.0456153 47.1421104 11.0456153"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-385",
    fill: "#000000",
    points: "47.6424587 15.4747451 48.141504 15.4747451 48.141504 14.490494 47.6424587 14.490494"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-386",
    fill: "#000000",
    points: "47.1421104 16.9498368 47.6411557 16.9498368 47.6411557 15.4747451 47.1421104 15.4747451"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-387",
    fill: "#000000",
    points: "47.1421104 18.918339 47.6411557 18.918339 47.6411557 17.4432473 47.1421104 17.4432473"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-388",
    fill: "#000000",
    points: "47.6424587 17.9379426 48.141504 17.9379426 48.141504 16.9485519 47.6424587 16.9485519"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-389",
    fill: "#000000",
    points: "47.6424587 19.4091796 48.141504 19.4091796 48.141504 18.917054 47.6424587 18.917054"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-390",
    fill: "#000000",
    points: "47.6424587 21.3815365 48.141504 21.3815365 48.141504 20.889411 47.6424587 20.889411"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-391",
    fill: "#000000",
    points: "48.140201 19.9051599 48.6392463 19.9051599 48.6392463 19.4117494 48.140201 19.4117494"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-392",
    fill: "#000000",
    points: "47.1421104 20.888126 47.6411557 20.888126 47.6411557 19.903875 47.1421104 19.903875"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-393",
    fill: "#000000",
    points: "48.140201 21.8723771 48.6392463 21.8723771 48.6392463 21.3802516 48.140201 21.3802516"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-394",
    fill: "#000000",
    points: "48.6392463 20.3972854 49.1382916 20.3972854 49.1382916 19.9051599 48.6392463 19.9051599"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-395",
    fill: "#000000",
    points: "49.1382916 20.888126 49.6373369 20.888126 49.6373369 20.3972854 49.1382916 20.3972854"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-396",
    fill: "#000000",
    points: "49.6373369 21.3815365 50.1389881 21.3815365 50.1389881 20.889411 49.6373369 20.889411"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-397",
    fill: "#000000",
    points: "50.1363821 21.8723771 50.6354274 21.8723771 50.6354274 21.3802516 50.1363821 21.3802516"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-398",
    fill: "#000000",
    points: "50.6367304 22.3645026 51.1370787 22.3645026 51.1370787 21.8723771 50.6367304 21.8723771"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-399",
    fill: "#000000",
    points: "49.6373369 22.859198 50.1389881 22.859198 50.1389881 22.3670725 49.6373369 22.3670725"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-400",
    fill: "#000000",
    points: "48.6392463 22.3645026 49.6373369 22.3645026 49.6373369 21.8723771 48.6392463 21.8723771"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-401",
    fill: "#000000",
    points: "51.1331697 22.859198 51.633518 22.859198 51.633518 22.3670725 51.1331697 22.3670725"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-402",
    fill: "#000000",
    points: "51.634821 23.3526085 52.1351692 23.3526085 52.1351692 22.859198 51.634821 22.859198"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-403",
    fill: "#000000",
    points: "54.6290927 29.258115 55.1281379 29.258115 55.1281379 28.272579 54.6290927 28.272579"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-404",
    fill: "#000000",
    points: "52.6329115 26.7949174 53.1319568 26.7949174 53.1319568 26.3027919 52.6329115 26.3027919"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-405",
    fill: "#000000",
    points: "52.1351692 24.8277002 52.6329115 24.8277002 52.6329115 24.3317199 52.1351692 24.3317199"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-406",
    fill: "#000000",
    points: "52.1351692 26.3053617 52.6329115 26.3053617 52.6329115 25.315971 52.1351692 25.315971"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-407",
    fill: "#000000",
    points: "53.1319568 27.287043 54.1300474 27.287043 54.1300474 26.7949174 53.1319568 26.7949174"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-408",
    fill: "#000000",
    points: "51.634821 27.287043 52.6342145 27.287043 52.6342145 26.7949174 51.634821 26.7949174"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-409",
    fill: "#000000",
    points: "52.6329115 27.7843082 53.1319568 27.7843082 53.1319568 27.2921826 52.6329115 27.2921826"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-410",
    fill: "#000000",
    points: "53.1319568 28.7659894 53.6310021 28.7659894 53.6310021 27.7778836 53.1319568 27.7778836"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-411",
    fill: "#000000",
    points: "54.1300474 28.272579 54.6277897 28.272579 54.6277897 27.285758 54.1300474 27.285758"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-412",
    fill: "#000000",
    points: "46.1427169 17.4445322 46.6404592 17.4445322 46.6404592 16.9498368 46.1427169 16.9498368"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-413",
    fill: "#000000",
    points: "45.1459293 18.4313531 45.6436716 18.4313531 45.6436716 17.9353728 45.1459293 17.9353728"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-414",
    fill: "#000000",
    points: "45.6436716 18.9221937 46.1427169 18.9221937 46.1427169 18.4313531 45.6436716 18.4313531"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-415",
    fill: "#000000",
    points: "44.6442781 17.9353728 45.1446263 17.9353728 45.1446263 17.4432473 44.6442781 17.4432473"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-416",
    fill: "#000000",
    points: "45.6436716 17.9353728 46.1427169 17.9353728 46.1427169 17.4432473 45.6436716 17.4432473"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-417",
    fill: "#000000",
    points: "54.1300474 29.7489556 54.6277897 29.7489556 54.6277897 29.2555451 54.1300474 29.2555451"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-418",
    fill: "#000000",
    points: "53.6336081 31.2253322 54.1313504 31.2253322 54.1313504 29.7502405 53.6336081 29.7502405"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-419",
    fill: "#000000",
    points: "49.1392037 30.7321787 49.1392037 31.2243042 50.1320823 31.2243042 50.1320823 31.7164298 49.1392037 31.7164298 49.1392037 32.2085553 53.1328689 32.2085553 53.1328689 31.7164298 50.6389455 31.7164298 50.6389455 31.2243042 51.1340818 31.2243042 51.1340818 30.7321787"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-420",
    fill: "#000000",
    points: "51.1331697 30.7319217 51.633518 30.7319217 51.633518 30.2397962 51.1331697 30.2397962"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-421",
    fill: "#000000",
    points: "51.634821 30.2410811 52.1351692 30.2410811 52.1351692 28.7659894 51.634821 28.7659894"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-422",
    fill: "#000000",
    points: "51.1331697 28.7659894 51.633518 28.7659894 51.633518 28.2738639 51.1331697 28.2738639"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-423",
    fill: "#000000",
    points: "50.1363821 28.272579 51.1396847 28.272579 51.1396847 27.7804534 50.1363821 27.7804534"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-424",
    fill: "#000000",
    points: "49.6373369 27.7804534 50.1389881 27.7804534 50.1389881 27.2883279 49.6373369 27.2883279"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-425",
    fill: "#000000",
    points: "48.140201 32.2082983 48.6392463 32.2082983 48.6392463 31.7161728 48.140201 31.7161728"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-426",
    fill: "#000000",
    points: "48.140201 30.7319217 49.1395946 30.7319217 49.1395946 30.2397962 48.140201 30.2397962"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-427",
    fill: "#000000",
    points: "49.1382916 27.287043 49.6373369 27.287043 49.6373369 26.7949174 49.1382916 26.7949174"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-428",
    fill: "#000000",
    points: "47.1421104 27.7804534 49.1395946 27.7804534 49.1395946 27.2883279 47.1421104 27.2883279"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-429",
    fill: "#000000",
    points: "46.1427169 25.3185408 46.6404592 25.3185408 46.6404592 24.8264153 46.1427169 24.8264153"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-430",
    fill: "#000000",
    points: "46.6404592 28.272579 47.1421104 28.272579 47.1421104 27.7804534 46.6404592 27.7804534"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-431",
    fill: "#000000",
    points: "46.6404592 27.287043 47.1421104 27.287043 47.1421104 26.7949174 46.6404592 26.7949174"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-432",
    fill: "#000000",
    points: "47.1421104 26.7949174 48.140201 26.7949174 48.140201 26.3027919 47.1421104 26.3027919"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-433",
    fill: "#000000",
    points: "49.1382916 25.8093814 49.6373369 25.8093814 49.6373369 24.8277002 49.1382916 24.8277002"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-434",
    fill: "#000000",
    points: "49.6373369 24.8277002 50.1389881 24.8277002 50.1389881 24.3317199 49.6373369 24.3317199"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-435",
    fill: "#000000",
    points: "51.1331697 26.7949174 51.633518 26.7949174 51.633518 26.3027919 51.1331697 26.3027919"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-436",
    fill: "#000000",
    points: "45.6436716 25.8093814 46.1427169 25.8093814 46.1427169 25.3185408 45.6436716 25.3185408"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-437",
    fill: "#000000",
    points: "44.645581 27.287043 45.1446263 27.287043 45.1446263 26.7949174 44.645581 26.7949174"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-438",
    fill: "#000000",
    points: "45.1459293 26.7974873 45.6436716 26.7974873 45.6436716 25.8093814 45.1459293 25.8093814"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-439",
    fill: "#000000",
    points: "44.1478388 27.7804534 44.645581 27.7804534 44.645581 27.2883279 44.1478388 27.2883279"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-440",
    fill: "#000000",
    points: "43.6487935 28.272579 44.1478388 28.272579 44.1478388 27.7804534 43.6487935 27.7804534"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-441",
    fill: "#000000",
    points: "43.1471422 29.258115 43.6474905 29.258115 43.6474905 28.272579 43.1471422 28.272579"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-442",
    fill: "#000000",
    points: "43.6487935 29.7489556 44.1478388 29.7489556 44.1478388 29.2555451 43.6487935 29.2555451"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-443",
    fill: "#000000",
    points: "42.1529606 31.7161728 42.6507029 31.7161728 42.6507029 31.2240473 42.1529606 31.2240473"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-444",
    fill: "#000000",
    points: "37.1585988 32.2082983 37.6576441 32.2082983 37.6576441 31.7161728 37.1585988 31.7161728"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-445",
    fill: "#000000",
    points: "37.6563411 31.7161728 38.1553864 31.7161728 38.1553864 31.2240473 37.6563411 31.2240473"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-446",
    fill: "#000000",
    points: "36.6595536 31.7200276 37.1585988 31.7200276 37.1585988 30.7319217 36.6595536 30.7319217"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-447",
    fill: "#000000",
    points: "37.1585988 30.7319217 38.1579924 30.7319217 38.1579924 30.2397962 37.1585988 30.2397962"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-448",
    fill: "#000000",
    points: "36.1579023 31.2253322 36.6595536 31.2253322 36.6595536 30.7332066 36.1579023 30.7332066"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-449",
    fill: "#000000",
    points: "39.6551282 30.7319217 40.1528705 30.7319217 40.1528705 30.2397962 39.6551282 30.2397962"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-450",
    fill: "#000000",
    points: "39.15478 31.7200276 39.6538252 31.7200276 39.6538252 30.7319217 39.15478 30.7319217"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-451",
    fill: "#000000",
    points: "40.1528705 30.2410811 40.6519158 30.2410811 40.6519158 29.7489556 40.1528705 29.7489556"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-452",
    fill: "#000000",
    points: "42.1529606 29.7489556 42.6507029 29.7489556 42.6507029 28.2738639 42.1529606 28.2738639"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-453",
    fill: "#000000",
    points: "40.6519158 29.7489556 41.1509611 29.7489556 41.1509611 26.7949174 40.6519158 26.7949174"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-454",
    fill: "#000000",
    points: "40.1528705 26.7949174 40.6519158 26.7949174 40.6519158 26.3027919 40.1528705 26.3027919"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-455",
    fill: "#000000",
    points: "39.15478 27.287043 40.1554765 27.287043 40.1554765 26.7949174 39.15478 26.7949174"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-456",
    fill: "#000000",
    points: "38.6557347 27.7804534 39.15478 27.7804534 39.15478 25.8093814 38.6557347 25.8093814"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-457",
    fill: "#000000",
    points: "39.15478 25.8093814 40.1554765 25.8093814 40.1554765 25.3185408 39.15478 25.3185408"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-458",
    fill: "#000000",
    points: "41.6526123 24.8277002 42.1516576 24.8277002 42.1516576 24.3317199 41.6526123 24.3317199"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-459",
    fill: "#000000",
    points: "40.1528705 25.3185408 41.6526123 25.3185408 41.6526123 24.8264153 40.1528705 24.8264153"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-460",
    fill: "#000000",
    points: "41.1509611 25.3185408 41.6526123 25.3185408 41.6526123 24.8264153 41.1509611 24.8264153"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-461",
    fill: "#000000",
    points: "42.1529606 24.3330048 43.1484452 24.3330048 43.1484452 23.8421642 42.1529606 23.8421642"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-462",
    fill: "#000000",
    points: "43.1471422 23.844734 43.6474905 23.844734 43.6474905 23.3526085 43.1471422 23.3526085"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-463",
    fill: "#000000",
    points: "43.6487935 23.3526085 44.645581 23.3526085 44.645581 22.859198 43.6487935 22.859198"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-464",
    fill: "#000000",
    points: "41.6526123 20.888126 42.6493999 20.888126 42.6493999 20.3972854 41.6526123 20.3972854"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-465",
    fill: "#000000",
    points: "41.1509611 21.3815365 41.6526123 21.3815365 41.6526123 20.889411 41.1509611 20.889411"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-466",
    fill: "#000000",
    points: "40.6519158 20.888126 41.1509611 20.888126 41.1509611 20.3972854 40.6519158 20.3972854"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-467",
    fill: "#000000",
    points: "38.6557347 21.3815365 40.6519158 21.3815365 40.6519158 20.889411 38.6557347 20.889411"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-468",
    fill: "#000000",
    points: "38.1540834 20.888126 38.6544317 20.888126 38.6544317 20.3972854 38.1540834 20.3972854"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-469",
    fill: "#000000",
    points: "38.1540834 21.8723771 38.6544317 21.8723771 38.6544317 21.3802516 38.1540834 21.3802516"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-470",
    fill: "#000000",
    points: "44.1478388 17.4445322 44.646884 17.4445322 44.646884 16.9498368 44.1478388 16.9498368"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-471",
    fill: "#000000",
    points: "43.1471422 19.4091796 43.6474905 19.4091796 43.6474905 18.917054 43.1471422 18.917054"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-472",
    fill: "#000000",
    points: "42.1490517 17.4445322 42.6480969 17.4445322 42.6480969 16.9498368 42.1490517 16.9498368"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-473",
    fill: "#000000",
    points: "43.6487935 14.9839045 44.645581 14.9839045 44.645581 14.491779 43.6487935 14.491779"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-474",
    fill: "#000000",
    points: "41.6500064 17.9353728 42.1490517 17.9353728 42.1490517 17.4432473 41.6500064 17.4432473"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-475",
    fill: "#000000",
    points: "40.6519158 18.4313531 41.6513094 18.4313531 41.6513094 17.9353728 40.6519158 17.9353728"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-476",
    fill: "#000000",
    points: "40.1528705 18.9221937 40.6519158 18.9221937 40.6519158 18.4313531 40.1528705 18.4313531"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-477",
    fill: "#000000",
    points: "38.6557347 19.9051599 39.15478 19.9051599 39.15478 18.4300682 38.6557347 18.4300682"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-478",
    fill: "#000000",
    points: "39.6512193 19.4091796 40.1515675 19.4091796 40.1515675 18.917054 39.6512193 18.917054"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-479",
    fill: "#000000",
    points: "39.15478 19.9051599 39.6538252 19.9051599 39.6538252 19.4117494 39.15478 19.4117494"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-480",
    fill: "#000000",
    points: "38.1540834 18.4313531 38.6544317 18.4313531 38.6544317 17.9353728 38.1540834 17.9353728"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-481",
    fill: "#000000",
    points: "38.1540834 16.4577113 38.6544317 16.4577113 38.6544317 15.9655857 38.1540834 15.9655857"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-482",
    fill: "#000000",
    points: "38.1540834 15.477315 38.6544317 15.477315 38.6544317 14.9839045 38.1540834 14.9839045"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-483",
    fill: "#000000",
    points: "40.6512643 16.4583537 40.6512643 16.9491943 40.153522 16.9491943 40.153522 17.4451746 41.6545668 17.4451746 41.6545668 16.4583537"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-484",
    fill: "#000000",
    points: "39.6551282 16.4577113 40.6506128 16.4577113 40.6506128 15.9655857 39.6551282 15.9655857"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-485",
    fill: "#000000",
    points: "38.6557347 15.9668706 39.6564312 15.9668706 39.6564312 15.4747451 38.6557347 15.4747451"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-486",
    fill: "#000000",
    points: "42.1519182 13.9957986 41.1499187 13.9957986 41.1499187 14.490494 40.6521764 14.490494 40.6521764 13.0141174 41.1499187 13.0141174 41.1499187 13.504958 42.1519182 13.504958"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-487",
    fill: "#000000",
    points: "42.6483575 14.9827481 42.6483575 15.4735887 43.1474028 15.4735887 43.1474028 16.4565548 42.6483575 16.4565548 42.6483575 16.9499653 43.6490541 16.9499653 43.6490541 14.9827481"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6441928,12.0288384 L46.1445411,12.0288384 L46.1445411,11.0458722 L45.6441928,11.0458722 L45.6441928,11.5367129 L45.1477535,11.5367129 L45.1477535,12.519679 L45.6441928,12.519679 L45.6441928,12.0288384 Z M46.6422834,10.5537467 L46.6422834,12.519679 L46.1445411,12.519679 L46.1445411,13.0156593 L45.1477535,13.0156593 L45.1477535,12.519679 L44.6447993,12.519679 L44.6447993,12.0288384 L44.14836,12.0288384 L44.14836,11.5367129 L44.6447993,11.5367129 L44.6447993,10.5537467 L46.6422834,10.5537467 Z",
    id: "Fill-488",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-489",
    fill: "#000000",
    points: "47.1432831 30.7321787 47.1432831 31.2255892 46.6416319 31.2255892 46.6416319 32.2085553 47.6423284 32.2085553 47.6423284 31.7164298 48.1413737 31.7164298 48.1413737 30.7321787"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-490",
    fill: "#000000",
    points: "35.6591176 31.2248182 35.6591176 32.2090693 36.6624201 32.2090693 36.6624201 31.7169438 36.1620719 31.7169438 36.1620719 31.2248182"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-491",
    fill: "#000000",
    points: "48.1407222 7.10629809 47.1426316 7.10629809 47.1426316 7.59842363 47.6416769 7.59842363 47.6416769 8.09311902 48.1407222 8.09311902 48.1407222 10.5524618 48.6397675 10.5524618 48.6397675 8.09054917 49.1401158 8.09054917 49.1401158 7.59842363 48.1407222 7.59842363"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-492",
    fill: "#000000",
    points: "46.6413713 8.58190375 46.6413713 9.07788406 47.1417195 9.07788406 47.1417195 9.56872468 47.6433708 9.56872468 47.6433708 8.58190375"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-493",
    fill: "#000000",
    points: "46.6413713 13.9963126 46.6413713 14.9844185 47.1417195 14.9844185 47.1417195 14.491008 47.6433708 14.491008 47.6433708 13.9963126"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-494",
    fill: "#000000",
    points: "43.6486632 16.9498368 43.6486632 17.9340879 44.1464055 17.9340879 44.1464055 17.4445322 44.6441478 17.4445322 44.6441478 16.9498368"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-495",
    fill: "#000000",
    points: "43.1520936 7.59880911 43.1494876 8.58177526 43.6485329 8.58177526 43.6485329 8.08964972 44.1475782 8.08964972 44.1475782 7.59880911 45.1443657 7.59880911 45.1443657 7.10668357 45.644714 7.10668357 45.644714 6.61327311 44.6479264 6.61327311 44.6479264 7.10668357 43.6485329 7.10668357 43.6485329 7.59880911"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-496",
    fill: "#000000",
    points: "44.6484476 8.0900352 44.6484476 9.07942597 45.6439322 9.07942597 45.6439322 10.063677 46.6420228 10.063677 46.6420228 9.56641182 46.1429775 9.56641182 46.1429775 9.07814105 45.6439322 9.07814105 45.6439322 8.58216074 45.1448869 8.58216074 45.1448869 8.0900352"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-497",
    fill: "#000000",
    points: "38.1540834 31.2253322 39.156083 31.2253322 39.156083 30.7332066 38.1540834 30.7332066"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-498",
    fill: "#000000",
    points: "45.1450172 19.409565 45.1502292 19.9081152 43.1501391 19.9081152 43.1462301 19.409565 42.6484878 19.409565 42.6484878 20.3976709 45.6440625 20.3976709 45.6440625 19.409565"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-499",
    fill: "#000000",
    points: "48.138898 24.3313344 48.145413 26.3049762 49.1395946 26.3049762 49.1395946 25.8102809 48.6379433 25.8102809 48.6379433 24.3313344"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-500",
    fill: "#000000",
    points: "42.6483575 29.7492126 42.6483575 31.2243042 43.1474028 31.2243042 43.1500088 30.2400532 43.6503571 30.2400532 43.6503571 29.7492126"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-501",
    fill: "#000000",
    points: "48.1407222 21.8728911 47.1426316 21.8728911 47.1426316 21.3807655 46.6422834 21.3781957 46.6422834 20.8873551 46.1432381 20.8873551 46.1432381 20.3965145 45.6441928 20.3965145 45.6441928 20.8873551 45.1451475 20.8873551 45.1451475 21.3807655 46.1432381 21.3807655 46.1432381 22.3650166 44.6487082 22.3650166 44.6487082 22.8584271 46.1432381 22.8584271 46.1432381 22.3650166 47.1426316 22.3650166 47.1426316 22.8584271 47.6416769 22.8584271 47.6416769 23.8426782 47.1426316 23.8426782 47.1426316 24.3309489 46.6422834 24.3309489 46.6422834 24.8282142 47.6416769 24.8282142 47.6416769 24.3309489 48.1407222 24.3309489"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-502",
    fill: "#000000",
    points: "48.138898 11.0451013 48.138898 12.520193 47.6411557 12.520193 47.6411557 13.0161733 48.145413 13.0123185 48.138898 13.5044441 47.6411557 13.5044441 47.6411557 13.9965696 48.145413 13.9965696 48.138898 14.491265 48.6379433 14.491265 48.6379433 11.0451013"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-503",
    fill: "#000000",
    points: "43.6477511 9.56821071 43.1513118 9.57078055 43.1487058 8.58138978 42.6483575 8.58138978 42.6483575 11.0420175 42.1519182 11.0420175 42.1519182 12.0288384 42.6483575 12.0288384 42.6483575 11.5354279 43.1487058 11.5354279 43.1513118 10.0577664 43.6477511 10.0603362"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-504",
    fill: "#000000",
    points: "53.1319568 31.7148879 53.6296991 31.7148879 53.6296991 31.2214774 53.1319568 31.2214774"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-505",
    fill: "#000000",
    points: "48.6444583 31.7161728 49.1330796 31.7161728 49.1330796 31.2240473 48.6444583 31.2240473"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(67.209725, 14.308469)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-506",
    fill: "#E5352C",
    points: "101.940488 3.57568394 105.422078 3.57568394 105.422078 0.179632246 101.940488 0.179632246"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-507",
    fill: "#E5352C",
    points: "108.300383 3.57568394 111.779368 3.57568394 111.779368 0.179632246 108.300383 0.179632246"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-508",
    fill: "#E5352C",
    points: "101.940488 9.88337132 105.422078 9.88337132 105.422078 6.48731963 101.940488 6.48731963"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-509",
    fill: "#E5352C",
    points: "108.300383 9.88337132 111.779368 9.88337132 111.779368 6.48731963 108.300383 6.48731963"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.42495503,1.60217058 C4.12787324,1.30920812 3.69658346,1.19356505 2.90697134,1.19356505 L1.2209019,1.19356505 L1.2209019,5.18839089 C1.90757779,5.26420135 2.19293266,5.27705058 2.53301313,5.27705058 C3.08548101,5.27705058 3.48549903,5.22179889 3.81645856,5.08945182 C4.53049724,4.79391951 4.98133188,4.0306752 4.98133188,3.11837982 C4.98133188,2.48748258 4.78588334,1.95552443 4.42495503,1.60217058 M2.74409755,6.32426289 C2.35580645,6.32426289 2.08739045,6.29342474 1.2209019,6.20476505 L1.2209019,9.88221489 L-3.69482223e-13,9.88221489 L-3.69482223e-13,0.174621046 L3.08548101,0.174621046 C4.28032311,0.174621046 4.93572722,0.381493662 5.48558913,0.941720123 C5.99375534,1.45697428 6.24523247,2.13284382 6.24523247,3.04256935 C6.24523247,5.07146289 4.90575845,6.32426289 2.74409755,6.32426289",
    id: "Fill-510",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2541073,1.47175089 C14.9570256,1.23532505 14.7016395,1.19292258 13.823424,1.19292258 L12.2272609,1.19292258 L12.2272609,4.7071872 L13.823424,4.7071872 C15.1185963,4.7071872 15.7922423,4.05830105 15.7922423,2.80935582 C15.7922423,2.18873797 15.6111267,1.74929428 15.2541073,1.47175089 L15.2541073,1.47175089 Z M16.2535009,9.88157243 L13.5406751,5.72227643 L12.2272609,5.72227643 L12.2272609,9.88157243 L11.003753,9.88157243 L11.003753,0.173978585 L14.0006307,0.173978585 C15.1941698,0.173978585 15.7609706,0.352582892 16.3290743,0.897390277 C16.8033628,1.35482289 17.1030506,2.06024566 17.1030506,2.79265182 C17.1030506,3.55846597 16.7890299,4.29215705 16.237865,4.8074112 C15.835241,5.20702228 15.4769187,5.38434166 14.7459411,5.54495705 L17.6542155,9.88157243 L16.2535009,9.88157243 Z",
    id: "Fill-512",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5191099,1.05762018 C24.5346557,1.05762018 22.9085238,2.8513728 22.9085238,5.03060234 C22.9085238,7.22011126 24.5346557,9.0151488 26.5191099,9.0151488 C28.4879282,9.0151488 30.1114541,7.22011126 30.1114541,5.03060234 C30.1114541,2.8513728 28.4879282,1.05762018 26.5191099,1.05762018 M26.5191099,10.0713556 C23.6564402,10.0713556 21.5677468,7.95765711 21.5677468,5.03060234 C21.5677468,2.1163968 23.6564402,0.000128492308 26.5191099,0.000128492308 C29.3817796,0.000128492308 31.4535341,2.1163968 31.4535341,5.03060234 C31.4535341,7.95765711 29.3817796,10.0713556 26.5191099,10.0713556",
    id: "Fill-514",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5324648,10.1311045 L38.7858514,10.1311045 L34.9081523,0.174235569 L36.2215665,0.174235569 L39.1285378,7.75014203 C39.1858694,7.88248911 39.2184442,8.03025526 39.2340801,8.22042388 C39.2340801,8.04310449 39.2627458,7.91075742 39.3252894,7.75014203 L42.1254155,0.174235569 L43.3489234,0.174235569 L39.5324648,10.1311045 Z",
    id: "Fill-516",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-518",
    fill: "#000000",
    points: "47.9315403 9.8820864 49.1537451 9.8820864 49.1537451 0.174492554 47.9315403 0.174492554"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5987357,9.89583508 L56.6851593,2.397024 C56.6408577,2.32378338 56.5652842,2.20557046 56.4910138,2.05908923 C56.4310762,1.95629538 56.3854716,1.89718892 56.3724417,1.83808246 C56.3112011,1.73528862 56.2812323,1.66076308 56.2212948,1.47187938 L56.2212948,9.88170092 L54.9990899,9.88170092 L54.9990899,0.174107077 L56.595253,0.174107077 L61.4723457,7.57269415 C61.5166473,7.63180062 61.560949,7.72046031 61.6065537,7.80783508 C61.6664912,7.95817108 61.6795211,7.97102031 61.7850633,8.24984862 C61.7993962,8.28197169 61.8163351,8.33850831 61.8436979,8.39632985 L61.8436979,0.174107077 L63.0672058,0.174107077 L63.0672058,9.89583508 L61.5987357,9.89583508 Z",
    id: "Fill-520",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5505043,1.83744 C74.8077998,1.32475569 74.0898521,1.10374892 73.1373662,1.10374892 C71.0473698,1.10374892 69.5593549,2.69062892 69.5593549,4.91226092 C69.5593549,7.35361477 71.0643087,8.95591385 73.3758135,8.95591385 C74.2097273,8.95591385 74.8521015,8.82485169 75.6417136,8.49976615 L75.9844,9.44161477 C75.3876305,9.70630892 75.1478803,9.79496862 74.6566529,9.91189662 C74.1654256,10.0301095 73.7641046,10.0712271 73.301543,10.0712271 C70.3307252,10.0712271 68.2290018,7.97037785 68.2290018,4.98678646 C68.2290018,2.14710646 70.3632999,-2.13162821e-14 73.1816679,-2.13162821e-14 C73.8240421,-2.13162821e-14 74.4494775,0.101508923 75.0306111,0.325085538 C75.4645069,0.471566769 75.6716824,0.589779692 76.1642127,0.927714462 L75.5505043,1.83744 Z",
    id: "Fill-521",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-522",
    fill: "#000000",
    points: "80.847681 9.8820864 82.0711889 9.8820864 82.0711889 0.174492554 80.847681 0.174492554"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-523",
    fill: "#000000",
    points: "87.9187487 9.88272886 87.9187487 0.175135015 93.4499425 0.175135015 93.4499425 1.19407902 89.1409536 1.19407902 89.1409536 4.42566055 92.704632 4.42566055 92.704632 5.43946486 89.1409536 5.43946486 89.1409536 8.86635471 93.5854535 8.86635471 93.5854535 9.88272886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.211985,9.36567582 C126.49534,9.85394658 125.660123,10.0710986 124.436615,10.0710986 C123.200077,10.0710986 122.396132,9.86808074 121.646913,9.36567582 C120.63449,8.67567212 120.306136,7.86745551 120.306136,6.08912197 L120.306136,0.174621046 L122.169412,0.174621046 L122.169412,6.19191582 C122.169412,7.63231458 122.931661,8.35315643 124.496553,8.35315643 C125.927236,8.35315643 126.688182,7.58734228 126.688182,6.19191582 L126.688182,0.174621046 L128.567094,0.174621046 L128.567094,6.08912197 C128.567094,7.86745551 128.240044,8.66282289 127.211985,9.36567582",
    id: "Fill-524",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-525",
    fill: "#000000",
    points: "137.425995 1.74903729 137.425995 9.88260037 135.547083 9.88260037 135.547083 1.74903729 132.593204 1.74903729 132.593204 0.1737216 140.378571 0.1737216 140.378571 1.74903729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.633621,1.74903729 L146.410113,1.74903729 L146.410113,4.42553206 L147.633621,4.42553206 C148.823251,4.42553206 149.34575,4.0156416 149.34575,3.04295483 C149.34575,2.11652529 148.855826,1.74903729 147.633621,1.74903729 L147.633621,1.74903729 Z M149.602439,9.88260037 L147.346963,5.99956283 L146.410113,5.99956283 L146.410113,9.88260037 L144.531201,9.88260037 L144.531201,0.1737216 L147.812131,0.1737216 C149.242814,0.1737216 149.899521,0.352325908 150.481958,0.897133292 C151.017487,1.38026437 151.285903,2.08825698 151.285903,3.00183729 C151.285903,3.75351729 151.108696,4.35486129 150.750374,4.82385822 C150.376416,5.29670991 150.033729,5.49972775 149.212845,5.72201945 L151.661164,9.88260037 L149.602439,9.88260037 Z",
    id: "Fill-526",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-527",
    fill: "#000000",
    points: "156.063577 9.88272886 156.063577 0.175135015 162.059939 0.175135015 162.059939 1.74916578 157.942489 1.74916578 157.942489 4.14683225 161.310719 4.14683225 161.310719 5.72214794 157.942489 5.72214794 157.942489 8.30998302 162.252781 8.30998302 162.252781 9.88272886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.564301,2.39651003 C172.924532,1.94036234 172.163586,1.72064049 171.2984,1.72064049 C169.405156,1.72064049 168.050046,3.04282634 168.050046,4.88412111 C168.050046,6.96955126 169.449457,8.33799434 171.595482,8.33799434 C172.299097,8.33799434 172.881534,8.21978142 173.759749,7.88313157 L174.103739,9.44174326 C173.477,9.71928665 173.221614,9.80666142 172.774688,9.91202511 C172.299097,10.0161039 171.776598,10.0713556 171.196767,10.0713556 C169.657936,10.0713556 168.555606,9.69101834 167.630483,8.86609772 C166.586788,7.94352295 165.975685,6.50183926 165.975685,4.98691495 C165.975685,3.57478449 166.51382,2.29500111 167.481942,1.35443742 C168.464397,0.3958848 169.568029,0.000128492308 171.196767,0.000128492308 C172.447638,0.000128492308 173.430093,0.294375877 174.280945,0.927842954 L173.564301,2.39651003 Z",
    id: "Fill-528",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-529",
    fill: "#000000",
    points: "185.601585 9.88272886 185.601585 5.72214794 180.543377 5.72214794 180.543377 9.88272886 178.667071 9.88272886 178.667071 0.175135015 180.543377 0.175135015 180.543377 4.05817255 185.601585 4.05817255 185.601585 0.175135015 187.477891 0.175135015 187.477891 9.88272886"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-530",
    fill: "#000000",
    points: "196.461358 1.74903729 196.461358 9.88260037 194.585052 9.88260037 194.585052 1.74903729 191.632476 1.74903729 191.632476 0.1737216 199.415237 0.1737216 199.415237 1.74903729"
  }))))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtrechtProvincieLogo);
export default __webpack_public_path__ + "static/media/utrecht_provincie_logo.32358b4ce904dc17a3fba15b7cbc18ca.svg";
export { ForwardRef as ReactComponent };